import {feats,spells,perks} from "../data.js"
export const levelUpPerks = {
    fighter:{
        tier1: [
            {
                id:1,
                name:"Improved Strength",
                desc:"Increase your strength by +1.",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.strength += 1                    
                }
            },{
                id:2,
                name:"Jock",
                desc:"Increase your strength by +2, but reduce your wisdom by -2 and intelligence by -1.",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.strength += 2
                    levelObj.baseStatsMods.abilityScores.wisdom -= 2
                    levelObj.baseStatsMods.abilityScores.intelligence -= 1
                }
            },{
                id:3,
                name:"Improved Charisma",
                desc:"Increases your charisma by +2.",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.charisma += 2
                }
            }],
            tier2:[
                {
                    id:1,
                    name:"Toughen",
                    desc:"Increase your HD size by 4.",
                    method:(levelObj)=>{
                        levelObj.baseStatsMods.hdSize += 4
                    }
                },
                {
                    id:2,
                    name:"Mental Toughness",
                    desc:"Increase your spell points per level by +0.5 and base spell points by +4.",
                    method:(levelObj)=>{
                        levelObj.baseStatsMods.spPerLevel += 0.5
                        levelObj.baseStatsMods.sp += 4
                    }
                },
                { 
                    id:3,
                    name:"Improved Resistance",
                    desc:"Increase your fortitude and reflex save by +2.",
                    method:(levelObj)=>{
                        levelObj.baseStatsMods.fortitude += 2
                        levelObj.baseStatsMods.reflex += 2
                    }
                },        
            ],
            tier3:[
                {
                    id:1,
                    name:"Weapon Master",
                    desc:"Increase your strength by +1 and convert three weapon rolls into a ranged weapon, a light weapon, and a two-handed weapon",
                    method:(levelObj)=>{
                        levelObj.baseStatsMods.abilityScores.strength += 1
                        let weapons = levelObj.rollRequests.find(obj=> obj.type == "weapon")
                        weapons.amount -= 3
                        levelObj.rollRequests.push({type:"weapon", amount:1, options:{weapon:{type:{ranged:true}, rarity:{common:true,rare:true,epic:true,legendary:true,unique:true}}}})
                        levelObj.rollRequests.push({type:"weapon", amount:1, options:{weapon:{type:{light:true}, rarity:{common:true,rare:true,epic:true,legendary:true,unique:true}}}})
                        levelObj.rollRequests.push({type:"weapon", amount:1, options:{weapon:{type:{twoHanded:true}, rarity:{common:true,rare:true,epic:true,legendary:true,unique:true}}}})

                    }
                },
                {
                    id:2,
                    name:"Additional Training",
                    desc:"Increase your charisma by +1 and gain one level 3 maneuver",
                    method:(levelObj)=>{
                        levelObj.rollRequests.push({type:"maneuver", amount:1, options:{level:{lvl3:true}}})
                        levelObj.baseStatsMods.abilityScores.charisma += 1
                    }
                },
                { 
                    id:3,
                    name:"Improved Genetics",
                    desc:"Increase your dexterity by +2 and gain an R+ stat roll",
                    method:(levelObj)=>{
                        levelObj.baseStatsMods.abilityScores.dexterity += 2
                        levelObj.rollRequests.push({type:"stats", amount:1, options:{rarity:{rare:true,epic:true,legendary:true,unique:true,}}})
                    }
                },        
            ],
            tier4:[
                {
                    id:1,
                    name:"Upgraded Arms",
                    desc:"Improve one of your weapon rolls into a R+ weapon roll",
                    method:(levelObj)=>{
                        let weapons = levelObj.rollRequests.find(obj=> obj.type == "weapon")
                        weapons.amount -= 1
                        levelObj.rollRequests.push({type:"weapon", amount:1, options:{weapon:{rarity:{rare:true,epic:true,legendary:true,unique:true}}}})
                    }
                },
                {
                    id:2,
                    name:"Upgraded Armor",
                    desc:"Improve one of your armor rolls into a R+ armor roll",
                    method:(levelObj)=>{
                        let armor = levelObj.rollRequests.find(obj=> obj.type == "armor")
                        armor.amount -= 1
                        levelObj.rollRequests.push({type:"armor", amount:1, options:{armor:{rarity:{rare:true,epic:true,legendary:true,unique:true}}}})
                    }
                },
                {
                    id:3,
                    name:"Bigger Pockets",
                    desc:"Gain 50 gold",
                    method:(levelObj)=>{
                        levelObj.baseStatsMods.gold += 50
                    }
                },
            ],
            tier5:[
                {
                    id:1,
                    name:"Trained Fighter",
                    desc:"Increase your strength by +1 and your unique perk becomes guaranteed martial.",
                    method:(levelObj)=>{
                        levelObj.rollRequests[0].options.type = {martial:true}
                        levelObj.baseStatsMods.abilityScores.strength += 1
                    }
                },
                {
                    id:2,
                    name:"Maneuver Training",
                    desc:"You gain +1 charisma the perk Maneuver Training: Reduce the spell point cost of all maneuvers by 33%. Your martial strikes gain a +2 bonus on their damage.",
                    method:(levelObj, context)=>{
                        levelObj.baseStatsMods.abilityScores.charisma += 1
                        context.stats.lists.perks.push({
                            name:"Maneuver Training",
                            prereq: "",
                            type:"martial",
                            rarity:"class",
                            uiType:"perks",
                            shortDesc:"Reduce the spell point cost of all maneuvers by 33%. Your martial strikes gain a +2 bonus on their damage."
                        }) 
                    }
                },
                {
                    id:3,
                    name:"Martial Training",
                    desc:"Increase your strength by +2 and gain a bonus martial key feat.",
                    method:(levelObj)=>{
                        levelObj.baseStatsMods.abilityScores.strength += 2
                        levelObj.rollRequests.push({type:"feats",  options:{martial:true, key:true}, amount:1})
                    }
                },
            ],
            tier6:[
                {
                    id:1,
                    name:"Grandmaster at Arms",
                    desc:"Increase your base attack bonus by +3",
                    method:(levelObj)=>{
                        levelObj.baseStatsMods.bab += 3
                    }
                },
                {
                    id:2,
                    name:"Discipline Master",
                    desc:"Gain two level 1 stances and one level 3 stance",
                    method:(levelObj)=>{
                        levelObj.rollRequests.push({type:"maneuver", amount:2, options:{type:{Stance:true}, level:{lvl1:true}}})
                        levelObj.rollRequests.push({type:"maneuver", amount:1, options:{type:{Stance:true}, level:{lvl3:true}}})
                    }
                },
                {
                    id:3,
                    name:"Legendary Weapon",
                    desc:"Turn one of your weapon rolls into a Epic+ weapon roll",
                    method:(levelObj)=>{
                        let weapons = levelObj.rollRequests.find(obj=> obj.type == "weapon")
                        weapons.amount -= 1
                        levelObj.rollRequests.push({type:"weapon", amount:1, options:{weapon:{rarity:{epic:true, legendary:true, unique:true}}}})
                    }
                },
            ],
    },
    monk:{
        tier1: [
            {
                id:1,
                name:"Path of Fire",
                desc:"Increase your strength by +1.",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.strength += 1                    
                }
            },{
                id:2,
                name:"Path of Stone",
                desc:"Increase your constitution by +1",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.constitution += 1
                }
            },{
                id:3,
                name:"Path of Water",
                desc:"Increases your dexterity and wisdom by +1, but reduce your constitution by -1.",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.constitution -= 1
                    levelObj.baseStatsMods.abilityScores.wisdom += 1
                    levelObj.baseStatsMods.abilityScores.dexterity += 1
                }
            }],
            tier2:[
                {
                    id:1,
                    name:"Toughen",
                    desc:"Increase your HD size by 4.",
                    method:(levelObj)=>{
                        levelObj.baseStatsMods.hdSize += 4
                    }
                },
                {
                    id:2,
                    name:"Ki Channeling",
                    desc:"Increase your spell points per level by +1 and base spell points by +6.",
                    method:(levelObj)=>{
                        levelObj.baseStatsMods.spPerLevel += 1
                        levelObj.baseStatsMods.sp += 6
                    }
                },
                { 
                    id:3,
                    name:"Improved Resistance",
                    desc:"Increase your fortitude, will, and reflex save by +1.",
                    method:(levelObj)=>{
                        levelObj.baseStatsMods.fortitude += 1
                        levelObj.baseStatsMods.reflex += 1
                        levelObj.baseStatsMods.will += 1
                    }
                },        
            ],
            tier3:[
                {
                    id:1,
                    name:"Esoteric Techniques",
                    desc:"Increase your strength by +1 and gain 2 additional style feats.",
                    method:(levelObj)=>{
                        levelObj.baseStatsMods.abilityScores.strength += 1
                        levelObj.rollRequests.push({type:"feats", options:{style:true}, amount:2})
                    }
                },
                {
                    id:2,
                    name:"Master Techniques",
                    desc:"Increase your wisdom by +1 and gain one level 3 maneuver",
                    method:(levelObj)=>{
                        levelObj.rollRequests.push({type:"maneuver", amount:1, options:{level:{lvl3:true},type:{Stance:true}}})
                        levelObj.baseStatsMods.abilityScores.wisdom += 1
                    }
                },
                { 
                    id:3,
                    name:"Improved Genetics",
                    desc:"Increase your dexterity by +2 and gain an R+ stat roll",
                    method:(levelObj)=>{
                        levelObj.baseStatsMods.abilityScores.dexterity += 2
                        levelObj.rollRequests.push({type:"stats", amount:1, options:{rarity:{rare:true,epic:true,legendary:true,unique:true,}}})
                    }
                },        
            ],
            tier4:[
                {
                    id:1,
                    name:"Monastic Weaponry",
                    desc:"Improve your augmenting weapon roll into a R+ augmenting weapon roll.",
                    method:(levelObj)=>{
                        let weapons = levelObj.rollRequests.find(obj=> obj.type == "weapon" && obj.options)
                        weapons.options.weapon.rarity = {rare:true,epic:true,legendary:true,unique:true}
                    }
                },
                {
                    id:2,
                    name:"Fast Movement",
                    desc:"Gain the perk Fast Movement: Increase your base land speed by 10 feet while in light or no armor, or 5 feet when in medium or heavy.",
                    method:(levelObj, context)=>{
                        levelObj.doNothing = "donothing"
                        context.stats.lists.perks.push({
                            name:"Fast Movement",
                            prereq: "",
                            id:Math.random(),
                            type:"universal",
                            rarity:"class",
                            uiType:"perks",
                            shortDesc:"Increase your base land speed by 10 feet while in light or no armor, or 5 feet when in medium or heavy."
                        }) 
                    }
                },
                {
                    id:3,
                    name:"Teachings of Prosperity",
                    desc:"Gain 50 gold",
                    method:(levelObj)=>{
                        levelObj.baseStatsMods.gold += 50
                    }
                },
            ],
            tier5:[
                {
                    id:1,
                    name:"Way of the Fist",
                    desc:"Increase your strength by +1 and your unique perk becomes guaranteed martial.",
                    method:(levelObj)=>{
                        levelObj.rollRequests[0].options.type = {martial:true}
                        levelObj.baseStatsMods.abilityScores.strength += 1
                    }
                },
                {
                    id:2,
                    name:"Way of Flowing Styles",
                    desc:"You gain +1 dexterity and gain the perk Way of Flowing Styles: Once per round for level/4 spell points you can swap your martial stance or style feat as a free action.",
                    method:(levelObj, context)=>{
                        levelObj.baseStatsMods.abilityScores.dexterity += 1
                        context.stats.lists.perks.push({
                            name:"Way of Flowing Styles",
                            prereq: "",
                            id:Math.random(),
                            type:"martial",
                            rarity:"class",
                            uiType:"perks",
                            shortDesc:"Once per round for level/4 spell points you can swap your martial stance or style feat as a free action."
                        }) 
                    }
                },
                {
                    id:3,
                    name:"Way of Many Styles",
                    desc:"Increase your wisdom by +1 and gain the perk Way of Many Styles: Once per combat as a free action for level spell points you can enter a second style feat or martial stance and maintain both at once. You can only have one of these active at once.",
                    method:(levelObj, context)=>{
                        levelObj.baseStatsMods.abilityScores.wisdom += 1
                        context.stats.lists.perks.push({
                            name:"Way of Flowing Styles",
                            prereq: "",
                            id:Math.random(),
                            type:"martial",
                            rarity:"class",
                            uiType:"perks",
                            shortDesc:"Once per combat as a free action for level spell points you can enter a second style feat or martial stance and maintain both at once. You can only have one of these active at once."
                        }) 

                    }
                },
            ],
            tier6:[
                {
                    id:1,
                    name:"Way of the Void",
                    desc:"Gain the perk Way of the Void: You can slip between space and time, appearing anywhere within sight. Doing this is an immediate action that costs level/2 spell points, and you take 1 point of wisdom drain. Each additional time you use this per floor, the wisdom drain doubles. This ability acts like teleportation, but bypasses any restrictions to teleportation, magic, or anything else that would stop the teleportation from completing as intended.",
                    method:(levelObj, context)=>{
                        levelObj.doNothing = "do nothing"
                        context.stats.lists.perks.push({
                            name:"Way of the Void",
                            prereq: "",
                            id:Math.random(),
                            type:"universal",
                            rarity:"class",
                            uiType:"perks",
                            abilityType:"Ex",
                            shortDesc:"You can slip between space and time, appearing anywhere within sight. Doing this is an immediate action that costs level/2 spell points, and you take 1 point of wisdom drain. Each additional time you use this per floor, the wisdom drain doubles. This ability acts like teleportation, but bypasses any restrictions to teleportation, magic, or anything else that would stop the teleportation from completing as intended."
                        }) 
                    }
                },
                {
                    id:2,
                    name:"Way of the Sun",
                    desc:"Gain the perk Way of the Sun: Once per floor you can activate this perk while dead when it would normally have been your turn in initiative. Doing this costs level x3 spell points, and you do not get to act on the turn you used this. You are restored to life as if you had the resurrection spell cast on you, except you only restore half your maximum hit points.",
                    method:(levelObj,context)=>{
                        levelObj.doNothing = "do nothing"
                        context.stats.lists.perks.push({
                            name:"Way of the Sun",
                            prereq: "",
                            id:Math.random(),
                            type:"universal",
                            rarity:"class",
                            uiType:"perks",
                            abilityType:"Su",
                            shortDesc:"Once per floor you can activate this perk while dead when it would normally have been your turn in initiative. Doing this costs level x4 spell points, and you do not get to act on the turn you used this. You are restored to life as if you had the resurrection spell cast on you, except you only restore half your maximum hit points."
                        }) 
                    }
                },
                {
                    id:3,
                    name:"Master of the Fist",
                    desc:"Gain the perk Master of the Fist: Increase the base damage of your unarmed attacks by 3 steps. If you are using an unarmed augmenting weapon this is reduced to 1 step. Your unarmed attacks don't provoke attacks of opportunity and deal lethal damage.",
                    method:(levelObj, context)=>{
                        levelObj.doNothing = "do nothing"
                        context.stats.lists.perks.push({
                            name:"Master of the Fist",
                            prereq: "",
                            id:Math.random(),
                            type:"martial",
                            rarity:"class",
                            uiType:"perks",
                            abilityType:"Ex",
                            shortDesc:"Increase the base damage of your unarmed attacks by 3 steps. If you are using an unarmed augmenting weapon this is reduced to 1 step. Your unarmed attacks don't provoke attacks of opportunity and deal lethal damage."
                        }) 
                    }
                },
            ],
    },
    barbarian:{
        tier1:[
            {
                id:1,
                name:"Improved Strength",
                desc:"Increase your strength by +1",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.strength += 1                    
                }
            },
            {
                id:2,
                name:"Primal Berserker",
                desc:"Increase your strength by +2, but reduce your intelligence, wisdom, and charisma by -1",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.strength += 2
                    levelObj.baseStatsMods.abilityScores.intelligence -= 1
                    levelObj.baseStatsMods.abilityScores.wisdom -= 1
                    levelObj.baseStatsMods.abilityScores.charisma -= 1
                }
            },
            {
                id:3,
                name:"Library Workout",
                desc:"Increase your intelligence by +2.",
                method:(levelObj)=>{                    
                    levelObj.baseStatsMods.abilityScores.intelligence += 2
                }
            },
        ],
        tier2:[
            {
                id:1,
                name:"Toughen",
                desc:"Increase your HD size by +4.",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.hdSize += 4
                }
            },
            {
                id:2,
                name:"Mental Toughness",
                desc:"Increase your spell points per level by +0.5, and base spell points by +3",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.spPerLevel += 0.5
                    levelObj.baseStatsMods.sp += 2

                }
            },
            { 
                id:3,
                name:"Improved Resistance",
                desc:"increase your fortitude and will save by +1",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.will += 1
                    levelObj.baseStatsMods.fortitude += 1
                }
            },
        ],
        tier3:[
            {
                id:1,
                name:"Destructive Training",
                desc:"Increase your strength by +1 and gain a level 3 strike.",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.strength += 1
                    levelObj.rollRequests.push({type:"maneuver", amount:1, options:{type:{Strike:true}, level:{lvl3:true}}})
                }
            },
            {
                id:2,
                name:"Improved Genetics",
                desc:"Increase your constitution by +1 and gain an additional R+ stat roll.",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.constitution += 1
                    levelObj.rollRequests.push({type:"stats", amount:1, options:{rarity:{rare:true,epic:true,legendary:true,unique:true,}}})
                }
            },
            {
                id:3,
                name:"Fearless Savage",
                desc:"Increase your strength by +2, decrease your dexterity by -2, gain 2 weapon rolls, and lose an armor roll.",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.strength += 2
                    levelObj.baseStatsMods.abilityScores.dexterity -= 2
                    let armor = levelObj.rollRequests.find(obj=> obj.type == "armor")
                    armor.amount -= 1
                    levelObj.rollRequests.push({type:"weapon", amount:2})
                }
            },
        ],            
        tier4:[
            {
                id:1,
                name:"Favourite Weapon",
                desc:"Turn one of your R+ weapon rolls into a R+ two-handed weapon roll",
                method:(levelObj)=>{
                    let weapon = levelObj.rollRequests.find(obj=> obj.type == "weapon" && obj.options)
                    weapon.amount -= 1
                    levelObj.rollRequests.push({type:"weapon", amount:1, options:{weapon:{type:{twoHanded:true}, rarity:{rare:true,epic:true,legendary:true,unique:true}}}})
                }
            },
            {
                id:2,
                name:"Shaman Blessed Garbs",
                desc:"Gain an enchanted clothing roll",
                method:(levelObj)=>{
                    levelObj.rollRequests.push({type:"armor", amount:1, options:{armor:{type:{clothing:true}, enchanted:true}}})
                }
            },
            {
                id:3,
                name:"Expanded Pockets",
                desc:"Gain 50 gold",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.gold += 50
                }
            },
        ],
        tier5:[
            {
                id:1,
                name:"Trained Rage",
                desc:"Increase your strength by +2 and your unique perk becomes guaranteed martial.",
                method:(levelObj)=>{
                    levelObj.rollRequests[0].options.type = {martial:true}
                    levelObj.baseStatsMods.abilityScores.strength += 2
                }
            },
            {
                id:2,
                name:"Unfeeling, Unthinking, Undying",
                desc:"Gain +4 constitution, but reduce all your mental ability scores by -2, additionally gain the perk Undying: You no longer die until your total number of negative hit points is equal to or greater than double your Constitution score.",
                method:(levelObj, context)=>{
                    levelObj.baseStatsMods.abilityScores.constitution += 4
                    levelObj.baseStatsMods.abilityScores.intelligence -= 2
                    levelObj.baseStatsMods.abilityScores.wisdom -= 2
                    levelObj.baseStatsMods.abilityScores.charisma -= 2
                    context.stats.lists.perks.push({
                        name:"Undying",
                        prereq: "",
                        type:"universal",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"You no longer die until your total number of negative hit points is equal to or greater than double your Constitution score."
                    }) 
                }
            },
            {
                id:3,
                name:"Scarred Rager",
                desc:"Gain +4 dexterity, and the perk Scarred: gain DR -/2, and once per floor when you would receive damage you can reduce the damage taken to 0. All additional effects of the attack happen as normal, as if it still did its original damage",
                method:(levelObj, context)=>{
                    levelObj.baseStatsMods.abilityScores.dexterity += 4
                    context.stats.lists.perks.push({
                        name:"Scarred",
                        prereq: "",
                        type:"universal",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"Gain DR -/2, and once per floor when you would receive damage you can reduce the damage taken to 0. All additional effects of the attack happen as normal, as if it still did its original damage"
                    }) 
                }
            },
        ],
        tier6:[
            {
                id:1,
                name:"Battle Frenzy",
                desc:"Gain the perk Battle Frenzy: When you confirm a critical hit you gain 2x your constitution modifier as temporary hit points, and your constitution modifier in temporary spell points. These last your level/2 rounds (minimum 1), and stack with themselves.",
                method:(levelObj, context)=>{
                    levelObj.doesNothing = {}
                    context.stats.lists.perks.push({
                        name:"Battle Frenzy",
                        prereq: "",
                        type:"universal",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"When you confirm a critical hit you gain 2x your constitution modifier as temporary hit points, and your constitution modifier in temporary spell points. These last your level/2 rounds (minimum 1), and stack with themselves"
                    })
                }
            },
            {
                id:2,
                name:"Barbarian Maxxing",
                desc:"Increase your strength by +5, reduce all mental ability scores by -2, reduce your spell points per level by 1, and base spell points by 5",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.strength += 5
                    levelObj.baseStatsMods.abilityScores.intelligence -= 2
                    levelObj.baseStatsMods.abilityScores.wisdom -= 2
                    levelObj.baseStatsMods.abilityScores.charisma -= 2
                    levelObj.baseStatsMods.spPerLevel -= 1
                    levelObj.baseStatsMods.sp -= 5
                }
            },
            {
                id:3,
                name:"Only Rage Left",
                desc:"Gain the perk Only Rage Left: When you would be knocked unconcious or killed due to being reduced below 0 hit points, you can instead choose to stay concious and alive for 1 round acting as normal, and you gain +4 attack and damage with weapon attacks against the creature that reduced you below 0 hit points. After 1 round you fall unconcious and begin dying or die as normal. If you would have died but are healed during the round you activated this perk you gain a temporary negative level that lasts the rest of the floor.",
                method:(levelObj, context)=>{
                    levelObj.doesNothing = {}
                    context.stats.lists.perks.push({
                        name:"Only Rage Left",
                        prereq: "",
                        type:"universal",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"When you would be knocked unconcious or killed due to being reduced below 0 hit points, you can instead choose to stay concious and alive for 1 round acting as normal, and you gain +4 attack and damage with weapon attacks against the creature that reduced you below 0 hit points. After 1 round you fall unconcious and begin dying or die as normal. If you would have died but are healed during the round you activated this perk you gain a temporary negative level that lasts the rest of the floor."
                    })
                }
            },
        ],
    },
    rogue:{
        tier1:[
            {
                id:1,
                name:"Arcane Dabbling",
                desc:"Gain +1 dexterity and intelligence, but -2 charisma",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.dexterity += 1
                    levelObj.baseStatsMods.abilityScores.intelligence += 1
                    levelObj.baseStatsMods.abilityScores.charisma -= 2
                }
            },
            {
                id:2,
                name:"Improved Dexterity",
                desc:"Gain +1 dexterity",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.dexterity += 1
                }
            },
            {
                id:3,
                name:"Cold Hearted Killer",
                desc:"Gain +3 dexterity, but -2 charisma and -1 constitution",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.dexterity += 3
                    levelObj.baseStatsMods.abilityScores.charisma -= 2
                    levelObj.baseStatsMods.abilityScores.constitution -= 1

                }
            },
        ],
        tier2:[
            {
                id:1,
                name:"Toughen",
                desc:"Increase your HD size by +3",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.hdSize += 3
                }
            },
            {
                id:2,
                name:"Mental Toughness",
                desc:"Increase your spell points per level by +1 and base spell points by +2",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.spPerLevel += 1
                    levelObj.baseStatsMods.spPerLevel += 2
                }
            },
            { 
                id:3,
                name:"Improved Resistance",
                desc:"increase your reflex by +2 and will save by +1",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.will += 1
                    levelObj.baseStatsMods.reflex += 2
                }
            },
        ],
        tier3:[
            {
                id:1,
                name:"Expert",
                desc:"Gain 2 skill rolls, and increase your charisma and intelligence by +1",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.intelligence += 1
                    levelObj.baseStatsMods.abilityScores.charisma += 1
                    levelObj.rollRequests.push({type:"stats", amount:2, options:{type:{skills:true}}})

                }
            },
            {
                id:2,
                name:"Smuggled Weapon",
                desc:"One of your weapons becomes a R+ light weapon, and gain +1 dexterity.",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.dexterity += 1
                    let weapon = levelObj.rollRequests.find(obj=> obj.type == "weapon")
                    weapon.amount -= 1
                    levelObj.rollRequests.push({type:"weapon", amount:1, options:{weapon:{type:{light:true}, rarity:{rare:true,epic:true,legendary:true, unique:true}}}})
                }
            },
            {
                id:3,
                name:"Bigger Pockets",
                desc:"Gain 150 gold and +1 dexterity",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.dexterity += 1
                    levelObj.baseStatsMods.gold += 150
                }
            },
        ],            
        tier4:[
            {
                id:1,
                name:"Skill Master",
                desc:"Two of your skills become R+ skills.",
                method:(levelObj)=>{
                    let skills = levelObj.rollRequests.find(obj=> obj.type == "stats" && obj.options)
                    skills.amount -= 2
                    levelObj.rollRequests.push({type:"stats", amount:2, options:{rarity:{rare:true, epic:true, legendary:true, unique:true}, type:{skills:true}}})
                }
            },
            {
                id:2,
                name:"Rogue's Leathers",
                desc:"One armor roll becomes an R+ light armor roll",
                method:(levelObj)=>{
                    let armor = levelObj.rollRequests.find(obj=> obj.type == "armor")
                    armor.amount -= 1
                    levelObj.rollRequests.push({type:"armor", amount:1, options:{armor:{type:{light:true}, rarity:{rare:true,epic:true,legendary:true, unique:true}}}})
                }
            },
            {
                id:3,
                name:"Rogue's Techniques",
                desc:"Gain 2 maneuvers and 1 stance from Heart of the Maelstrom, Thrashing Dragon, Veiled Moon, Steel Serpent, or Mithral Current",
                method:(levelObj)=>{
                    levelObj.rollRequests.push({type:"maneuver", amount:2, options:{school:{heartOfTheMaelstrom:true,thrashingDragon:true,veiledMoon:true,mithralCurrent:true, steelSerpent:true}, level:{lvl1:true,lvl2:true}}})
                    levelObj.rollRequests.push({type:"maneuver", amount:2, options:{school:{heartOfTheMaelstrom:true,thrashingDragon:true,veiledMoon:true,mithralCurrent:true, steelSerpent:true}, type:{stance:true}, level:{lvl1:true}}})
                }
            },
        ],
        tier5:[
            {
                id:1,
                name:"Assassin's Edge",
                desc:"Gain +1 bab and the perk Assassin's Edge: Gain +2 attack against creatures flanked by allies, even if you aren't the one flanking it. This stacks with other flanking bonuses",
                method:(levelObj, context)=>{
                    levelObj.baseStatsMods.bab += 1
                    context.stats.lists.perks.push({
                        name:"Assassin's Edge",
                        prereq: "",
                        uiType:"perks",
                        rarity:"class",
                        type:"martial",
                        shortDesc:"Gain +2 attack against creatures flanked by allies, even if you aren't the one flanking it. This stacks with other flanking bonuses."
                    })
                }
            },
            {
                id:2,
                name:"Rogue's Reflexes",
                desc:"Gain +1 dexterity, and the perk Rogue's Reflexes: Gain a +2 dodge bonus to AC vs all attacks of opportunity, increase your movement speed by 10 feet, and can move at half speed while prone.",
                method:(levelObj, context)=>{
                    levelObj.baseStatsMods.abilityScores.dexterity += 1
                    context.stats.lists.perks.push({
                        name:"Rogue's Reflexes",
                        prereq: "",
                        type:"universal",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"Gain a +2 dodge bonus to AC vs all attacks of opportunity, increase your movement speed by 10 feet, and can move at half speed while prone."
                    })
                }
            },
            {
                id:3,
                name:"Opportunistic",
                desc:"Gain +1 charisma, and the perk Opportunistic: Gain an additional attack of opportunity a round, gain +2 on all d20 rolls you make while initiating a counter (including maneuvers and other counter attack rolls such as parry and reposte), and reduce counter maneuvers spell point cost by 1 spell point, this cannot reduce the cost of a counter below 1 spell point.",
                method:(levelObj, context)=>{
                    levelObj.baseStatsMods.abilityScores.charisma += 1
                    context.stats.lists.perks.push({
                        name:"Opportunistic",
                        prereq: "",
                        type:"martial",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"Gain additional attack of opportunity a round, gain +1 on all d20 rolls you make while initiating a counter (including maneuvers and other counter attack rolls such as parry and reposte), and reduce counter maneuvers spell point cost by 1 spell point, this cannot reduce the cost of a counter below 1 spell point."
                    })
                }
            },
        ],
        tier6:[
            {
                id:1,
                name:"Rogue's Luck",
                desc:"Gain the perk Rogue's Luck: Gain 1-6 additional gold on small piles, 1-12 on medium piles, and 1-18 on large piles.",
                method:(levelObj, context)=>{
                    levelObj.doesNothing = {}
                    context.stats.lists.perks.push({
                        name:"Rogue's Luck",
                        prereq: "",
                        type:"universal",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"Gain 1-6 additional gold on small piles, 1-12 on medium piles, and 1-18 on large piles. (this is added automatically)"
                    })
                }
            },
            {
                id:2,
                name:"Multi-Talented",
                desc:"Lose 2 perks, gain 5 common-rare perks",
                method:(levelObj)=>{
                    levelObj.rollRequests[1].amount -=2
                    levelObj.rollRequests.push({type:"perk", amount:5, options:{rarity:{common:true, rare:true,}}})
                }
            },
            {
                id:3,
                name:"Assassin's Strike",
                desc:"Gain the perk Assassin's Strike: Gain 1d6 sneak attack damage, for every source of sneak attack you have including feats or perks that increase current sneak attack, (other than Assassin's Strike) gain another additional 1d6 sneak attack damage.",
                method:(levelObj, context)=>{
                    levelObj.doesNothing = {}
                    context.stats.lists.perks.push({
                        name:"Assassin's Strike",
                        prereq: "",
                        type:"martial",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"Gain 1d6 sneak attack damage, for every source of sneak attack you have including feats or perks that increase current sneak attack, (other than Assassin's Strike) gain another additional 1d6 sneak attack damage."
                    })
                }
            },
        ],
    },
    tank:{
        tier1:[
            {
                id:1,
                name:"Improved Strength",
                desc:"Increase your strength by +1.",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.strength += 1
                }
            },
            {
                id:2,
                name:"Improved Constitution",
                desc:"Increase your constitution by +1.",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.constitution += 1
                }
            },
            {
                id:3,
                name:"Taken a Hit or Two",
                desc:"Gain +2 constitution, but -2 intelligence and -1 charisma",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.constitution += 2
                    levelObj.baseStatsMods.abilityScores.intelligence -= 2
                    levelObj.baseStatsMods.abilityScores.charisma -= 1
                }
            },
        ],
        tier2:[
            {
                id:1,
                name:"Toughen",
                desc:"Increase your HD size by 6",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.hdSize += 6
                }
            },
            {
                id:2,
                name:"Mental Toughness",
                desc:"Increase your spell points per level by +0.5 and base spell points by +3",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.spPerLevel += 0.5
                    levelObj.baseStatsMods.sp += 3
                }
            },
            { 
                id:3,
                name:"Improved Resistance",
                desc:"increase your fortitude reflex and will by +1.",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.fortitude += 1
                    levelObj.baseStatsMods.will += 1
                    levelObj.baseStatsMods.reflex += 1
                }
            },
        ],
        tier3:[
            {
                id:1,
                name:"Improved Genetics",
                desc:"Increase your constitution by +1 and gain an R+ stat roll.",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.constitution += 1
                    levelObj.rollRequests.push({type:"stats", amount:1, options:{rarity:{rare:true,epic:true,legendary:true,unique:true,}}})
                }
            },
            {
                id:2,
                name:"The best Defense...",
                desc:"Increase your strength by +1 and gain a weapon roll.",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.strength += 1
                    let weapon = levelObj.rollRequests.find(obj=> obj.type == "weapon")
                    weapon.amount += 1                    
                }
            },
            {
                id:3,
                name:"Bigger Pockets",
                desc:"Gain 50 gold and +1 to will and fortitude saves.",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.fortitude += 1
                    levelObj.baseStatsMods.will += 1
                    levelObj.baseStatsMods.gold += 50
                }
            },
        ],            
        tier4:[
            {
                id:1,
                name:"Vanguard",
                desc:"Convert two armor rolls into a heavy armor roll and a shield roll",
                method:(levelObj)=>{
                    let armor = levelObj.rollRequests.find(obj=> obj.type == "armor")
                    armor.amount -= 2
                    levelObj.rollRequests.push({type:"armor", amount:1, options:{armor:{type:{shield:true}}}})
                    levelObj.rollRequests.push({type:"armor", amount:1, options:{armor:{type:{heavy:true}}}})
                }
            },
            {
                id:2,
                name:"Improved Armaments",
                desc:"Convert an armor roll into a R+ armor roll",
                method:(levelObj)=>{
                    let armor = levelObj.rollRequests.find(obj=> obj.type == "armor")
                    armor.amount -= 1                    
                    levelObj.rollRequests.push({type:"armor", amount:1, options:{armor:{rarity:{rare:true,epic:true,legendary:true,unique:true}}}})
                }
            },
            {
                id:3,
                name:"Defensive Training",
                desc:"Gain 2 level 1-3 counter maneuver rolls",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.strength += 1
                    levelObj.rollRequests.push({type:"maneuver", amount:2, options:{type:{Counter:true}, level:{lvl1:true, lvl2:true, lvl3:true}}})
                }
            },
        ],
        tier5:[
            {
                id:1,
                name:"Armor Master",
                desc:"Gain +2 dexterity and the perk Armor Master: Increase the max dexterity of any armor you wear by 2, and reduce its armor check penalty by 3.",
                method:(levelObj, context)=>{
                    levelObj.baseStatsMods.abilityScores.dexterity += 2
                    context.stats.lists.perks.push({
                        name:"Armor Master",
                        prereq: "",
                        type:"martial",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"Increase the max dexterity of any armor you wear by 2, and reduce its armor check penalty by 3."
                    })
                }
            },
            {
                id:2,
                name:"Martial Training",
                desc:"You gain +1 strength and your unique perk becomes guaranteed martial.",
                method:(levelObj)=>{
                    levelObj.rollRequests[0].options.type = {martial:true}
                    levelObj.baseStatsMods.abilityScores.strength += 2
                }
            },
            {
                id:3,
                name:"Unbreakable",
                desc:"Gain +1 to all saves and the perk Unbreakable: Once per day as an immediate action you may reroll a saving throw directly after you failed, if you succeed on this reroll and you were not the only target of the ability that caused you to make that save any creature that also failed the save may also reroll that save as an immediate action",
                method:(levelObj, context)=>{
                    levelObj.baseStatsMods.abilityScores.dexterity += 2
                    context.stats.lists.perks.push({
                        name:"Unbreakable",
                        prereq: "",
                        type:"universal",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"Once per day as an immediate action you may reroll a saving throw directly after you failed, if you succeed on this reroll and you were not the only target of the ability that caused you to make that save any creature that also failed the save may also reroll that save as an immediate action"
                    })
                }
            },
        ],
        tier6:[
            {
                id:1,
                name:"Tanked Up",
                desc:"Gain +4 HD size, +2 constitution, +2 dexterity, and +1 to all saves",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.constitution += 2
                    levelObj.baseStatsMods.abilityScores.dexterity += 2
                    levelObj.baseStatsMods.hdSize += 4
                    levelObj.baseStatsMods.will += 1
                    levelObj.baseStatsMods.fortitude += 1
                    levelObj.baseStatsMods.reflex += 1

                }
            },
            {
                id:2,
                name:"Legendary Armor",
                desc:"One of your armor rolls becomes a Epic+ armor",
                method:(levelObj)=>{
                    let armor = levelObj.rollRequests.find(obj=> obj.type == "armor")
                    armor.amount -= 1
                    levelObj.rollRequests.push({type:"armor", amount:1, options:{weapon:{rarity:{epic:true, legendary:true,unique:true}}}})
                }
            },
            {
                id:3,
                name:"Indomitable",
                desc:"Gain the perk Indomitable: At the start of each floor you gain temporary hit points equal to half your maximum hit points. These temporary hit points stack with all other temporary hit points, and last 3 rounds",
                method:(levelObj, context)=>{
                    levelObj.doesNothing = {}
                    context.stats.lists.perks.push({
                        name:"Indomitable",
                        prereq: "",
                        type:"universal",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"At the start of each floor you gain temporary hit points equal to half your maximum hit points. These temporary hit points stack with all other temporary hit points, and last 3 rounds"
                    })
                }
            },
        ],
    },
    ranger:{
        tier1:[
            {
                id:1,
                name:"Improved Strength",
                desc:"Gain +1 strength",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.strength += 1
                }
            },
            {
                id:2,
                name:"Improved Dexterity",
                desc:"Gain +1 dexterity",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.dexterity += 1
                }
            },
            {
                id:3,
                name:"Wilderness Expert",
                desc:"Gain +2 intelligence and wisdom, but -2 constitution and -2 strength",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.intelligence += 2
                    levelObj.baseStatsMods.abilityScores.wisdom += 2
                    levelObj.baseStatsMods.abilityScores.strength -= 2
                    levelObj.baseStatsMods.abilityScores.constitution -= 2
                }
            },
        ],
        tier2:[
            {
                id:1,
                name:"Toughen",
                desc:"Increase your HD size by 4",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.hdSize += 4
                }
            },
            {
                id:2,
                name:"Mental Toughness",
                desc:"Increase your spell points per level by +0.5 and base spell points by +4",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.spPerLevel += 0.5
                    levelObj.baseStatsMods.sp += 4
                }
            },
            { 
                id:3,
                name:"Improved Resistance",
                desc:"Gain a +1 to fortitude saves, and +2 to reflex saves",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.fortitude += 1
                    levelObj.baseStatsMods.reflex += 2
                }
            },
        ],
        tier3:[            
            {
                id:1,
                name:"Tools of the Trade",
                desc:"Gain +1 dexterity and turn your ranged weapon into a R+ ranged weapon, and your two other weapon rolls into light weapons",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.dexterity += 1
                    let weapon = levelObj.rollRequests.find(obj=> obj.type == "weapon" && obj.options)
                    weapon.amount -= 1
                    let weapon2 = levelObj.rollRequests.find(obj=> obj.type == "weapon" && !obj.options)
                    weapon2.amount -= 2
                    levelObj.rollRequests.push({type:"weapon", amount:1, options:{weapon:{type:{ranged:true}, rarity:{rare:true,epic:true,legendary:true,unique:true}}}})
                    levelObj.rollRequests.push({type:"weapon", amount:1, options:{weapon:{type:{light:true}}}})                  
                }
            },
            {
                id:2,
                name:"Improved Genetics",
                desc:"Increase your strength by +1 and gain an R+ stat roll.",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.strength += 1
                    levelObj.rollRequests.push({type:"stats", amount:1, options:{rarity:{rare:true,epic:true,legendary:true,unique:true,}}})
                }
            },
            {
                id:3,
                name:"Rare Pelt",
                desc:"Gain +1 to wisdom and 75 gold.",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.wisdom += 1
                    levelObj.baseStatsMods.gold += 75
                }
            },
        ],            
        tier4:[
            {
                id:1,
                name:"Forest Survivor",
                desc:"Gain a utility feat, a level 1 buff spell, and a level 1 healing spell.",
                method:(levelObj)=>{
                    levelObj.rollRequests.push({type:"feats",  options:{utility:true}, amount:1})
                    levelObj.rollRequests.push({type:"spell", amount:1, options:{level:{lvl1:true}, type:{healing:true}}})
                    levelObj.rollRequests.push({type:"spell", amount:1, options:{level:{lvl1:true}, type:{buff:true}}})
                }
            },
            {
                id:2,
                name:"Deadly Shooter",
                desc:"Gain a tempest gale or solar wind level 3 maneuver and level 1 stance.",
                method:(levelObj)=>{                         
                    levelObj.rollRequests.push({type:"maneuver", amount:1, options:{school:{tempestGale:true,solarWind:true}, level:{lvl3:true}}})
                    levelObj.rollRequests.push({type:"maneuver", amount:1, options:{type:{Stance:true}, school:{tempestGale:true,solarWind:true}, level:{lvl1:true}}})
                    
                }
            },
            {
                id:3,
                name:"Ranger's Signature Cloak",
                desc:"One armor roll becomes a R+ light armor roll, and you gain a C-E shoulder wonderous item.",
                method:(levelObj)=>{
                    let armor = levelObj.rollRequests.find(obj=> obj.type == "armor")
                    armor.amount -= 1
                    levelObj.rollRequests.push({type:"armor", amount:1, options:{armor:{type:{light:true}, rarity:{rare:true,epic:true,legendary:true,unique:true}}}})
                    levelObj.rollRequests.push({type:"wonderousItems", amount:1, options:{type:{shoulders:true}, rarity:{common:true, rare:true,epic:true,}}})

                }
            },
        ],
        tier5:[
            {
                id:1,
                name:"Ranger's Fighting Styles",
                desc:"Gain +1 bab and on character creation you can choose between precise shot or two-weapon fighting.",
                method:(levelObj, context)=>{
                levelObj.baseStatsMods.bab += 1
                let choices = [
                    {
                        title:"Two-Weapon Fighting",
                        id:1, 
                        method:(context=>{                            
                            let feat = feats.filter(feat=> feat.name == "Two-Weapon Fighting")
                            context.stats.lists.feats.push(feat[0])
                        })
                    },
                    {
                        title:"Precise Shot",
                        id:2, 
                        method:(context=>{                            
                            let feat = feats.filter(feat=> feat.name == "Precise Shot")
                            context.stats.lists.feats.push(feat[0])
                        })
                    }

                ]
                let custom = {title:"Ranger's Fighting Styles", options:choices}
                context.customDialogArray.push(custom)
                }
            },
            {
                id:2,
                name:"Martial Training",
                desc:"Your unique perk becomes martial, and you gain +2 strength.",
                method:(levelObj)=>{
                    levelObj.rollRequests[0].options.type = {martial:true}
                    levelObj.baseStatsMods.abilityScores.strength += 2
                }
            },
            {
                id:3,
                name:"Know Thy Enemy",
                desc:"Gain +2 to intelligence and the perk Know Thy Enemy: Gain +2 to checks to identify the weaknesses of creatures that are identified with knowledge nature, and +1 to attack and damage against them, plus an additional +1 if you successfully identify the creature yourself. Increase it to +2 if you beat the DC to identify them by 8.",
                method:(levelObj, context)=>{
                    levelObj.baseStatsMods.abilityScores.dexterity += 2
                    context.stats.lists.perks.push({
                        name:"Know Thy Enemy",
                        prereq: "",
                        type:"universal",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"Gain +2 to checks to identify the weaknesses of creatures that are identified with knowledge nature, and +1 to attack and damage against them, plus an additional +1 if you successfully identify the creature yourself. Increase it to +2 if you beat the DC to identify them by 8."
                    })
                }
            },
        ],
        tier6:[
            {
                id:1,
                name:"Hunter's Mark",
                desc:"Gain the perk Hunters Mark: Once per day as a swift action you can pick a target you can currently see, until the start of your next turn whenever that creature would take damage, it takes an additional 1d6 damage. During that round when you attack the target you can ignore any concealment, even total concealment.",
                method:(levelObj, context)=>{                    
                    levelObj.doesNothing = {}
                    context.stats.lists.perks.push({
                        name:"Hunter's Mark",
                        prereq: "",
                        type:"universal",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"Once per day as a swift action you can pick a target you can currently see, until the start of your next turn whenever that creature would take damage, it takes an additional 1d6 damage. During that round when you attack the target you can ignore any concealment, even total concealment."
                    })
                }
            },
            {
                id:2,
                name:"Favoured Enemy",
                desc:"Gain the perk Favoured Enemy: On character creation (you cannot delay this choice) choose any type of creature, (and a subtype if you chose outsiders). All attacks against this creature type gain +4 to attack and damage, and you gain a +2 to saves against abilities used by them. Once per day when making an attack against your favoured enemy you can declare it a masterful shot, if it hits the creature must make a fortitude save DC 10+BAB+level/2, if they fail they die, if it saves it takes 5 damage per level. This is a death effect and the damage is untyped, but if the creature is immune to death effects and fails the save it instead takes 10 damage per level, or 5 per level if it succeeds. This additional damage is not multiplied on a critical hit unless the natural roll for the attack is a 20.",
                method:(levelObj, context)=>{
                    levelObj.doesNothing = {}
                    context.stats.lists.perks.push({
                        name:"Favoured Enemy",
                        prereq: "",
                        type:"universal",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"On character creation (you cannot delay this choice) choose any type of creature, (and a subtype if you chose outsiders). All attacks against this creature type gain +4 to attack and damage. Once per day when making an attack against your favoured enemy you can declare it a masterful shot, if it hits the creature must make a fortitude save DC 10+BAB+level/2, if they fail they die, if it saves it takes 5 damage per level. This is a death effect and the damage is untyped, but if the creature is immune to death effects and fails the save it instead takes 10 damage per level, or 5 per level if it succeeds. This additional damage is not multiplied on a critical hit unless the natural roll for the attack is a 20."
                    })
                }
            },
            {
                id:3,
                name:"Arrow Dancer",
                desc:"Gain the perk Arrow Dancer: For 4 spell points you can take a 5-foot step directly after firing a ranged weapon. This movement still provokes attacks of opportunity, but you can take this 5-foot step even after taking a 5-foot step or moving, but cannot move to a square you have previously been on this round. Gain +1 dodge bonus to armor class until the start of your next turn each time you use this ability.",
                method:(levelObj, context)=>{
                    levelObj.doesNothing = {}
                    context.stats.lists.perks.push({
                        name:"Arrow Dancer",
                        prereq: "",
                        type:"universal",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"For 4 spell points you can take a 5-foot step directly after firing a ranged weapon. This movement still provokes attacks of opportunity, but you can take this 5-foot step even after taking a 5-foot step or moving, but cannot move to a square you have previously been on this round. Gain +1 dodge bonus to armor class until the start of your next turn each time you use this ability."
                    })
                }
            },
        ],
    },
    warpriest:{
        tier1:[
            {
                id:1,
                name:"Improved Strength",
                desc:"Gain +1 strength",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.strength += 1
                }
            },
            {
                id:2,
                name:"Improved Wisdom",
                desc:"Gain +2 wisdom",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.wisdom += 2
                }
            },
            {
                id:3,
                name:"Improved Dexterity",
                desc:"Gain +2 dexterity",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.dexterity += 2
                }
            },
        ],
        tier2:[
            {
                id:1,
                name:"Toughen",
                desc:"Increase your HD size by 4",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.hdSize += 4
                }
            },
            {
                id:2,
                name:"Mental Toughness",
                desc:"Increase your spell points per level by 1 and base spell points by +4",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.spPerLevel += 1
                    levelObj.baseStatsMods.sp += 4
                }
            },
            { 
                id:3,
                name:"Improved Resistance",
                desc:"increase your fortitude by 1, and will by 1",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.fortitude += 1
                    levelObj.baseStatsMods.will += 1
                }
            },
        ],
        tier3:[
            {
                id:1,
                name:"Improved Genetics",
                desc:"Gain an R+ stat roll and increase your strength by +1",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.strength += 1
                    levelObj.rollRequests.push({type:"stats", amount:1, options:{rarity:{rare:true,epic:true,legendary:true,unique:true,}}})
                }
            },
            {
                id:2,
                name:"Divine Power",
                desc:"Gain a level 1-3 buff or healing spell and +1 wisdom",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.wisdom += 1
                    levelObj.rollRequests.push({type:"spell", amount:1, options:{level:{lvl1:true, lvl2:true, lvl3:true}, type:{buff:true, healing:true}}})
                }
            },
            {
                id:3,
                name:"Missionary Funding",
                desc:"Gain 75 gold",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.gold += 75
                }
            },
        ],            
        tier4:[
            {
                id:1,
                name:"Healer Training",
                desc:"Your level 1 healing spell becomes cure light wounds",
                method:(levelObj, context)=>{
                    let healingSpell = levelObj.rollRequests.find(obj=> obj.type == "spell" && obj.options && obj.options.type.healing)
                    healingSpell.amount -= 1
                    let spell = spells.filter(spell=> spell.name.includes("Cure Light Wounds"))
                    context.stats.lists.spells.push(spell[0])
                }
            },
            {
                id:2,
                name:"Reckless Faith",
                desc:"lose 1 armor roll and gain an R+ weapon roll",
                method:(levelObj)=>{
                    let armor = levelObj.rollRequests.find(obj=> obj.type == "armor")
                    armor.amount -= 1
                    levelObj.rollRequests.push({type:"weapon", amount:1, options:{weapon:{rarity:{rare:true,epic:true,legendary:true,unique:true}}}})
                }
            },
            {
                id:3,
                name:"Beacon of the Dawn",
                desc:"Gain 2 level 1-2 Radiant Dawn maneuvers",
                method:(levelObj)=>{
                    levelObj.rollRequests.push({type:"maneuver", amount:2, options:{school:{radiantDawn:true}, level:{lvl1:true,lvl2:true}}})
                }
            },
        ],
        tier5:[
            {
                id:1,
                name:"Faithful's Shield",
                desc:"Gain +1 dexterity and the perk Faithful's Shield: You can cast spells while wielding a shield as if the arm wielding the shield wasn't occupied for casting the spell, and whenever you attempt to cast a healing or buff spell while wielding a shield, your shield bonus to your armor class increases by the level of the spell for 1 round. This bonus applies before the completion of the spell and therefor applies to any attacks of opportunity caused by you casting the spell.",
                method:(levelObj, context)=>{
                    levelObj.baseStatsMods.abilityScores.dexterity += 1
                    context.stats.lists.perks.push({
                        name:"Faithful's Shield",
                        prereq: "",
                        type:"magic",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"You can cast spells while wielding a shield as if the arm wielding the shield wasn't occupied for casting the spell, and whenever you attempt to cast a healing or buff spell while wielding a shield, your shield bonus to your armor class increases by the level of the spell for 1 round. This bonus applies before the completion of the spell and therefor applies to any attacks of opportunity caused by you casting the spell."
                    }) 
                }
            },
            {
                id:2,
                name:"Gift of the Charitable",
                desc:"Gain +1 wisdom and the perk Gift of the Charitable: Once per turn per ability or spell when an ability you use heals another creature and not you, you heal your wisdom modifier hit points",
                method:(levelObj, context)=>{
                    levelObj.baseStatsMods.abilityScores.wisdom += 1
                    context.stats.lists.perks.push({
                        name:"Gift of the Charitable",
                        prereq: "",
                        type:"magic",
                        shortDesc:"Once per round per ability when an ability or spell you use heals another creature and not you, you heal your wisdom modifier(only wisdom) hit points"
                    }) 
                }
            },
            {
                id:3,
                name:"Wrath of the Blessed",
                desc:"Gain +1 strength and the perk Wrath of the Blessed: You gain +1 damage per spell currently affecting you (even including non-beneficial spells). You can dispel a beneficial spell currently affecting you as a free action to gain a sacred bonus to your attacks for 1 round equal to the spells level",
                method:(levelObj, context)=>{
                    levelObj.baseStatsMods.abilityScores.strength += 1
                    context.stats.lists.perks.push({
                        name:"Wrath of the Blessed",
                        prereq: "",
                        type:"martial",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"You gain +1 damage per spell currently affecting you (even including non-beneficial spells). You can dispel a beneficial spell currently affecting you as a free action to gain a sacred bonus to your attacks for 1 round equal to the spells level"
                    }) 
                }
            },
        ],
        tier6:[
            {
                id:1,
                name:"Faith's Fervor",
                desc:"Gain the perk Faith's Fervor: Once per day you can activate this ability to cast any one spell with a casting time of 1 round or shorter. When cast in this way, the spell can target only you, even if it could normally affect other or multiple targets. Spells cast in this way ignore somatic components and do not provoke attacks of opportunity. You do not need to have a free hand to cast a spell in this way.",
                method:(levelObj, context)=>{
                    levelObj.doesNothing = {}
                    context.stats.lists.perks.push({
                        name:"Faith's Fervor",
                        prereq: "",
                        type:"magic",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"Once per day you can activate this ability to cast any one spell with a casting time of 1 round or shorter. When cast in this way, the spell can target only you, even if it could normally affect other or multiple targets. Spells cast in this way ignore somatic components and do not provoke attacks of opportunity. You do not need to have a free hand to cast a spell in this way."
                    }) 
                }
            },
            {
                id:2,
                name:"Shepard of the Dawn",
                desc:"Gain the perk Shepard of the Dawn: All of your martial maneuvers that heal hit points heal an additional amount equal to twice your level. If a maneuver splits up its healing this extra amount must be split the same way. Additionally, whenever you use a martial maneuver heal hit points equal to the level of the maneuver.",
                method:(levelObj, context)=>{
                    levelObj.doesNothing = {}
                    context.stats.lists.perks.push({
                        name:"Shepard of the Dawn",
                        prereq: "",
                        type:"magic",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"All of your martial maneuvers that heal hit points heal an additional amount equal to twice your level. If a maneuver splits up its healing this extra amount must be split the same way. Additionally, whenever you use a martial maneuver you heal hit points equal to the level of the maneuver, this is a positive energy effect."
                    }) 
                }
            },
            {
                id:3,
                name:"Hand's of the Healer",
                desc:"Gain the perk Hand's of the Healer: All of your healing spells and perks that heal hit points have the amount they heal increased by your level. If a spell or perk heals without rolling any dice instead increase the healing by 1.",
                method:(levelObj, context)=>{
                    levelObj.doesNothing = {}
                    context.stats.lists.perks.push({
                        name:"Shepard of the Dawn",
                        prereq: "",
                        type:"magic",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"All of your martial maneuvers that heal hit points heal an additional amount equal to twice your level. If a maneuver splits up its healing this extra amount must be split the same way. Additionally, whenever you use a martial maneuver you heal hit points equal to the level of the maneuver, this is a positive energy effect."
                    }) 
                }
            },
        ],
    },
    eldritchKnight:{
        tier1:[
            {
                id:1,
                name:"Reckless Knight",
                desc:"Increase your strength and constitution by +2, but reduce your dexterity, wisdom and charisma by -2",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.strength += 2
                    levelObj.baseStatsMods.abilityScores.constitution += 2
                    levelObj.baseStatsMods.abilityScores.dexterity -= 2
                    levelObj.baseStatsMods.abilityScores.wisdom -= 2
                    levelObj.baseStatsMods.abilityScores.charisma -= 2
                }
            },
            {
                id:2,
                name:"Improved Strength",
                desc:"Increase your strength by +1",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.strength += 1
                }
            },
            {
                id:3,
                name:"Library Workout",
                desc:"Gain +2 intelligence",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.intelligence += 2
                }
            },
        ],
        tier2:[
            {
                id:1,
                name:"Toughen",
                desc:"Increase your HD size by 4",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.hdSize += 4
                }
            },
            {
                id:2,
                name:"Mental Toughness",
                desc:"Increase your spell points per level by +1 and base spell points by +2",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.spPerLevel += 1
                    levelObj.baseStatsMods.sp += 2
                }
            },
            { 
                id:3,
                name:"Improved Resistance",
                desc:"increase your fortitude and will save by +1",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.will += 1
                    levelObj.baseStatsMods.fortitude += 1
                }
            },
        ],
        tier3:[
            {
                id:1,
                name:"Tools of Destruction",
                desc:"Gain +2 strength and -1 dexterity, and gain 2 weapon rolls, but lose 1 armor rolls",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.strength += 2
                    levelObj.baseStatsMods.abilityScores.dexterity -= 1
                    let armor = levelObj.rollRequests.find(obj=> obj.type == "armor")
                    armor.amount -= 1
                    let weapon = levelObj.rollRequests.find(obj=> obj.type == "weapon")
                    weapon.amount += 2                    
                }
            },
            {
                id:2,
                name:"Arcane Knowledge",
                desc:"Gain a level 1-3 buff spell, and +1 intelligence",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.intelligence += 1
                    levelObj.rollRequests.push({type:"spell", amount:1, options:{level:{lvl1:true, lvl2:true, lvl3:true}, type:{buff:true}}})
                }
            },
            {
                id:3,
                name:"Expanded Pockets",
                desc:"Gain 50 gold and +2 intelligence",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.intelligence += 2
                    levelObj.baseStatsMods.gold += 50
                }
            },
        ],            
        tier4:[
            {
                id:1,
                name:"Knight's Gear",
                desc:"Lose 2 armor rolls and 2 weapon rolls to gain a R+ weapon roll and an R+ armor roll.",
                method:(levelObj)=>{                    
                    let armor = levelObj.rollRequests.find(obj=> obj.type == "armor")
                    armor.amount -= 2
                    let weapon = levelObj.rollRequests.find(obj=> obj.type == "weapon")
                    weapon.amount -= 2
                    levelObj.rollRequests.push({type:"armor", amount:1, options:{armor:{rarity:{rare:true,epic:true,legendary:true,unique:true}}}})
                    levelObj.rollRequests.push({type:"weapon", amount:1, options:{weapon:{rarity:{rare:true,epic:true,legendary:true,unique:true}}}})
                }
            },
            {
                id:2,
                name:"Hitting The Books",
                desc:"Gain 2 level 1 and level 2 spells",
                method:(levelObj)=>{
                    levelObj.rollRequests.push({type:"spell", amount:2, options:{level:{lvl1:true}}})
                    levelObj.rollRequests.push({type:"spell", amount:2, options:{level:{lvl2:true}}})
                }
            },
            {
                id:3,
                name:"Arcane Destroyer",
                desc:"Gain 2 level 1-3 damage spells",
                method:(levelObj)=>{
                    levelObj.rollRequests.push({type:"spell", amount:1, options:{level:{lvl1:true, lvl2:true, lvl3:true}, type:{damage:true}}})                   
                }
            },
        ],
        tier5:[
            {
                id:1,
                name:"Rune Carved Soul",
                desc:"Gain +1 intelligence and the perk Rune Carved Soul: Once per run you can cast a spell on yourself, the duration of that spell becomes permanent, even lasting through floors. If the spell is dispelled you can reactivate it as a movement action.",
                method:(levelObj, context)=>{
                    levelObj.baseStatsMods.abilityScores.intelligence += 1
                    context.stats.lists.perks.push({
                        name:"Rune Carved Soul",
                        prereq: "",
                        type:"magic",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"Once per run you can cast a spell on yourself, the duration of that spell becomes permanent, even lasting through floors. If the spell is dispelled you can reactivate it as a movement action."
                    })
                }
            },
            {
                id:2,
                name:"Aura of Destruction",
                desc:"Gain +1 constitution and the perk Aura of Destruction: When you cast a spell gain a deflection bonus to your armor class equal to the level of the spell for 1 round, and for rounds equal to the level of the spell cast any monster that damages you you with a non-reach melee weapon or a natural attack takes damage equal to 2x your highest mental mod.",
                method:(levelObj, context)=>{
                    levelObj.baseStatsMods.abilityScores.constitution += 1
                    context.stats.lists.perks.push({
                        name:"Aura of Destruction",
                        prereq: "",
                        type:"magic",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"When you cast a spell gain a deflection bonus to your armor class equal to the level of the spell for 1 round, and for rounds equal to the level of the spell cast any creature that damages you you with a non-reach melee weapon or a natural attack takes damage equal to 2x your highest mental mod."
                    })
                }
            },
            {
                id:3,
                name:"Rend Resistance",
                desc:"Gain +1 strength and the perk Rend Resistance: When you attack and damage a creature with a weapon attack, it gets a penalty of -1 to its next saving throw against a spell you cast within 1 round. This penalty stacks.",
                method:(levelObj, context)=>{
                    levelObj.baseStatsMods.abilityScores.strength += 1
                    context.stats.lists.perks.push({
                        name:"Rend Resistance",
                        prereq: "",
                        type:"magic",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"When you attack and damage a creature with a weapon attack, it gets a penalty of -1 to its next saving throw against a spell you cast within 1 round. This penalty stacks."
                    })
                }
            },
        ],
        tier6:[
            {
                id:1,
                name:"Transferable Knowledge",
                desc:"Gain the perk Transferable Knowledge: Once per day you can cast a spell for 2x the normal cost, the DC of the spell becomes 10+bab+spell level, plus any modifiers to the DC that would normally affect the spells DC.",
                method:(levelObj, context)=>{
                    levelObj.doesNothing = {}
                    context.stats.lists.perks.push({
                        name:"Transferable Knowledge",
                        prereq: "",
                        type:"magic",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"Once per day you can cast a spell for 2x the normal cost, the DC of the spell becomes 10+bab+spell level, plus any modifiers to the DC that would normally affect the spells DC."
                    })
                }
            },
            {
                id:2,
                name:"Critical Destruction",
                desc:"Gain the perk Critical Destruction: 3 times per day when you successfully confirm a critical hit with a weapon you may as a swift action cast a spell targetting the creature you confirmed the critical hit against. Any spell cast this way costs 2x its usual amount, and can only target and affect the one creature, even if the spell usually has an area of affect, it only affects the one creature. You must meet all normal requirements of the spell such as range to use it on the creature. This spell does not provoke attacks of opportunity.",
                method:(levelObj, context)=>{
                    levelObj.doesNothing = {}
                    context.stats.lists.perks.push({
                        name:"Critical Destruction",
                        prereq: "",
                        type:"magic",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"3 times per day when you successfully confirm a critical hit with a weapon you may as a swift action cast a spell targetting the creature you confirmed the critical hit against. Any spell cast this way costs 2x its usual amount, and can only target and affect the one creature, even if the spell usually has an area of affect, it only affects the one creature. You must meet all normal requirements of the spell such as range to use it on the creature. This spell does not provoke attacks of opportunity."
                    })
                }
            },
            {
                id:3,
                name:"Eldritch Blade",
                desc:"Gain the perk Eldritch Blade: Any weapon you wield gains a +1 enhancement modifier, and deals 1d6 elemental (fire, cold, electricity, acid) damage. You can change which damage type it deals as a swift action for 3 spell points.",
                method:(levelObj, context)=>{
                    levelObj.doesNothing = {}
                    context.stats.lists.perks.push({
                        name:"Eldritch Blade",
                        prereq: "",
                        type:"martial",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"Any weapon you wield gains a +1 enhancement modifier, and deals 1d6 elemental (fire, cold, electricity, acid) damage. You can change which damage type it deals as a swift action for 3 spell points."
                    })
                }
            },
        ],
    },
    arcaneTrickster:{
        tier1:[
            {
                id:1,
                name:"Street Skills",
                desc:"Gain +2 dexterity and -1 intelligence",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.dexterity += 2
                    levelObj.baseStatsMods.abilityScores.intelligence -= 1
                }
            },
            {
                id:2,
                name:"Improved Dexterity",
                desc:"Gain +1 dexterity",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.dexterity += 1
                }
            },
            {
                id:3,
                name:"Theoretically Good",
                desc:"Gain +1 intelligence",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.intelligence += 1
                }
            },
        ],
        tier2:[
            {
                id:1,
                name:"Toughen",
                desc:"Increase your HD size by 2",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.hdSize += 2
                }
            },
            {
                id:2,
                name:"Mental Toughness",
                desc:"Increase your spell points per level by 1.5 and base spell points by +2",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.spPerLevel += 1.5
                    levelObj.baseStatsMods.sp += 2
                }
            },
            { 
                id:3,
                name:"Improved Resistance",
                desc:"Increase your reflex by 2 and will save by 1",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.reflex += 2
                    levelObj.baseStatsMods.will += 1
                }
            },
        ],
        tier3:[
            {
                id:1,
                name:"Expert",
                desc:"Gain two skill rolls, and increase your intelligence by +1",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.intelligence += 1
                    levelObj.rollRequests.push({type:"stats", amount:2, options:{type:{skills:true}}})

                }
            },
            {
                id:2,
                name:"Arcane Knowledge",
                desc:"Gain three level 1 spells and +2 intelligence",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.intelligence += 2
                    levelObj.rollRequests.push({type:"spell", amount:3, options:{level:{lvl1:true}}})                    
                }
            },
            {
                id:3,
                name:"Expanded Pockets",
                desc:"Gain 75 gold and +2 dexterity",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.dexterity += 2
                    levelObj.baseStatsMods.gold += 75
                }
            },
        ],            
        tier4:[
            {
                id:1,
                name:"Magic Knife",
                desc:"One of your weapons becomes an enchanted light weapon",
                method:(levelObj)=>{                    
                    let weapon = levelObj.rollRequests.find(obj=> obj.type == "weapon")
                    weapon.amount -= 1
                    levelObj.rollRequests.push({type:"weapon", amount:1, options:{weapon:{type:{light:true}, class:{melee:true,ranged:false,enchanted:true}}}})
                }
            },
            {
                id:2,
                name:"Technique's of the Trickster",
                desc:"Gain two level 1 stances from veiled moon, elemental flux, sleeping goddess, shattered mirror, cursed razor, and riven hourglass",
                method:(levelObj)=>{
                    levelObj.rollRequests.push({type:"maneuver", amount:2, options:{school:{veiledMoon:true, elementalFlux:true, sleepingGoddess:true, shatteredMirror:true, cursedRazor:true, rivenHourglass:true}, level:{lvl1:true}}})
                }
            },
            {
                id:3,
                name:"Stolen Goods",
                desc:"Gain 75 Gold and a common-epic wonderous item",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.gold += 75
                    levelObj.rollRequests.push({type:"wonderousItems", amount:1, options:{rarity:{common:true,rare:true,epic:true}}})
                }
            },
        ],
        tier5:[
            {
                id:1,
                name:"Ingenious Tools",
                desc:"Gain +1 intelligence and the perk Ingenious Tools: Curative or Mnemonic potions you drink or feed to others restore 1 additional spell point or hit point per dice rolled, gear you use has its DC increased by your intelligence modifier (only intelligence), and once per day as a standard action for 5 spell points you can create and drink or feed someone a mysterious potion, this provokes an attack of opportunity.",
                method:(levelObj, context)=>{
                    levelObj.baseStatsMods.abilityScores.intelligence += 1
                    context.stats.lists.perks.push({
                        name:"Ingenious Tools",
                        prereq: "",
                        type:"universal",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"Curative or Mnemonic potions you drink or feed to others restore 1 additional spell point or hit point per dice rolled, gear you use has its DC increased by your intelligence modifier, and once per day as a standard action for 5 spell points you can create and drink or feed someone a mysterious potion, this provokes an attack of opportunity."
                    })
                }
            },
            {
                id:2,
                name:"Arcane Shroud",
                desc:"Gain +1 dexterity and the perk Arcane Shroud: For every spell currently affecting you (including spells cast by enemies), you gain a 5% miss chance, this doesn't stack with any other type of miss chance, but if you have a miss chance caused by a spell increase the miss chance of that spell by 1% per spell affecting you.",
                method:(levelObj, context)=>{
                    levelObj.baseStatsMods.abilityScores.dexterity += 1
                    context.stats.lists.perks.push({
                        name:"Arcane Shroud",
                        prereq: "",
                        type:"magic",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"For every spell currently affecting you (including spells cast by enemies), you gain a 5% miss chance, this doesn't stack with any other type of miss chance, but if you have a miss chance caused by a spell increase the miss chance of that spell by 1% per spell affecting you."
                    })
                }
            },
            {
                id:3,
                name:"Boogie Woogie",
                desc:"Gain +2 intelligence and the perk Boogie Woogie: Once per day as a swift action for level/2 spell points you can swap the position of yourself and any other creature you can see, or any ally whether you can see them or not. The destination for the other creature must not be an inherently dangerous location, and it must have enough space to fit them otherwise this ability automatically fails. After using this ability the next attack both you and the teleported creature make within 1 round is made against flat-footed armor class",
                method:(levelObj, context)=>{
                    levelObj.baseStatsMods.abilityScores.dexterity += 1
                    context.stats.lists.perks.push({
                        name:"Boogie Woogie",
                        prereq: "",
                        type:"magic",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"Once per day as a swift action for level/2 spell points you can swap the position of yourself and any other creature you can see, or any ally whether you can see them or not. The destination for the other creature must not be an inherently dangerous location, and it must have enough space to fit them otherwise this ability automatically fails. After using this ability the next attack both you and the teleported creature make within 1 round is made against flat-footed armor class"
                    })
                }
            },
        ],
        tier6:[
            {
                id:1,
                name:"Magical Trinket Expert",
                desc:"Gain the perk Magical Trinket Expert: You can activate up to two wonderous items at the same time as apart of the same standard action. On one of your wonderous item slots you can have two items equipped, but you must choose a different slot to no longer have access to.",
                method:(levelObj, context)=>{
                    levelObj.doesNothing = {}
                    context.stats.lists.perks.push({
                        name:"Magical Trinket Expert",
                        prereq: "",
                        type:"magic",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"You can activate up to two wonderous items at the same time as apart of the same standard action. On one of your wonderous item slots you can have two items equipped, but you must choose a different slot to no longer have access to."
                    })
                }
            },
            {
                id:2,
                name:"Jack of All Trades",
                desc:"Your unique perk becomes utility typed",
                method:(levelObj)=>{
                    levelObj.rollRequests[0].options.type = {universal:true}
                }
            },
            {
                id:3,
                name:"Unexpected Trick",
                desc:"Gain the perk Unexpect Trick: When a creature misses an attack against you because of a spell you cast or because of an ability you activated that caused the attack to miss, the creature becomes flat-footed against you for your next attack against it within 1 round. This even affects misses caused by bonus armor class, as long as the attack only missed because of the bonus armor class gained.",
                method:(levelObj, context)=>{
                    levelObj.doesNothing = {}
                    context.stats.lists.perks.push({
                        name:"Unexpected Trick",
                        prereq: "",
                        type:"martial",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"When a creature misses an attack against you because of a spell you cast or because of an ability you activated that caused the attack to miss, the creature becomes flat-footed against you for your next attack against it within 1 round. This even affects misses caused by bonus armor class, as long as the attack only missed because of the bonus armor class gained."
                    })
                }
            },
        ],
    },
    wizard:{
        tier1:[
            {
                id:1,
                name:"Improved Intelligence",
                desc:"Increase your intelligence by +1",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.intelligence += 1                    
                }
            },
            {
                id:2,
                name:"Years of Experience",
                desc:"Increase your intelligence by +2, but reduce your constitution by -2",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.intelligence += 2
                    levelObj.baseStatsMods.abilityScores.constitution -= 2
                }
            },
            {
                id:3,
                name:"Scientific Diet",
                desc:"Gain +1 constitution",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.constitution += 1
                }
            },
        ],
        tier2:[
            {
                id:1,
                name:"Toughen",
                desc:"Increase your HD size by 2",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.hdSize += 2
                }
            },
            {
                id:2,
                name:"Mental Toughness",
                desc:"Increase your spell points per level by +1.5 and increase base spell points by 4",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.spPerLevel += 1.5
                    levelObj.baseStatsMods.sp += 4
                }
            },
            { 
                id:3,
                name:"Improved Resistance",
                desc:"increase your will save by +1 and reflex save by +2",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.will += 1
                    levelObj.baseStatsMods.reflex += 2
                }
            },
        ],
        tier3:[
            {
                id:1,
                name:"Student of the Arcane",
                desc:"Gain +1 intelligence and a level 1 and level 2 spell.",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.intelligence += 1
                    levelObj.rollRequests.push({type:"spell", amount:1, options:{level:{lvl1:true}}})
                    levelObj.rollRequests.push({type:"spell", amount:1, options:{level:{lvl2:true}}})
                }
            },
            {
                id:2,
                name:"Polystudy",
                desc:"Gain +2 dexterity and 2 level 1-2 maneuvers",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.dexterity += 2
                    levelObj.rollRequests.push({type:"maneuver", amount:2, options:{level:{lvl1:true,lvl2:true}}})
                }
            },
            {
                id:3,
                name:"Research Grant",
                desc:"Gain 100 gold and increase your constitution by +1",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.constitution += 1
                    levelObj.baseStatsMods.gold += 100
                }
            },
        ],            
        tier4:[
            {
                id:1,
                name:"Mage's Armor",
                desc:"Gain an armor roll",
                method:(levelObj)=>{
                    levelObj.rollRequests.push({type:"armor", amount:1})
                }
            },
            {
                id:2,
                name:"Focused Study",
                desc:"Gain two level 1-3 spells",
                method:(levelObj)=>{                    
                    levelObj.rollRequests.push({type:"spell", amount:2, options:{level:{lvl1:true, lvl2:true, lvl3:true}}})
                }
            },
            {
                id:3,
                name:"Breadth of Knowledge",
                desc:"Gain five level 1-2 spells",
                method:(levelObj)=>{                    
                    levelObj.rollRequests.push({type:"spell", amount:5, options:{level:{lvl1:true, lvl2:true}}})
                }
            },
        ],
        tier5:[
            {
                id:1,
                name:"Archmage",
                desc:"Gain +1 intelligence and your unique perk becomes typed magic",
                method:(levelObj)=>{
                    levelObj.rollRequests[0].options.type = {magic:true}
                    levelObj.baseStatsMods.abilityScores.intelligence += 1
                }
            },
            {
                id:2,
                name:"Caster Master",
                desc:"Gain +1 intelligence and the perk Caster Master: Reduce the spell point cost of all spells by 1, you can reduce the cost of spells to 0 spell points",
                method:(levelObj, context)=>{
                    levelObj.baseStatsMods.abilityScores.intelligence += 1
                    context.stats.lists.perks.push({
                        name:"Caster Master",
                        prereq: "",
                        type:"magic",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"Reduce the spell point cost of all spells by 1, you can reduce the cost of spells to 0 spell points with this perk."
                    })
                }
            },
            {
                id:3,
                name:"Fueled by Knowledge",
                desc:"Gain +1 constitution and the perk Fueled by Knowledge: Each time you level up regain spell points equal to how many spells you currently know/2.",
                method:(levelObj, context)=>{
                    levelObj.baseStatsMods.abilityScores.constitution += 1
                    context.stats.lists.perks.push({
                        name:"Fueled by Knowledge",
                        prereq: "",
                        type:"magic",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"Each time you level up regain spell points equal to how many spells you currently know/2."
                    })
                }
            },
        ],
        tier6:[
            {
                id:1,
                name:"Master of Magic",
                desc:"Gain the perk Master of Magic: You count as 1 level higher for all of your magical perks and spells. This extra level bypasses any usual damage or other caster level limits on spells.",
                method:(levelObj, context)=>{
                    levelObj.doesNothing = {}
                    context.stats.lists.perks.push({
                        name:"Master of Magic",
                        prereq: "",
                        type:"magic",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"You count as 1 level higher for all of your magical perks and spells. This extra level bypasses any usual damage or other caster level limits on spells."
                    })
                }
            },
            {
                id:2,
                name:"Wild Magic",
                desc:"Gain the perk Wild Magic: Once per day for level 2x plus the cost of the spell 2x spell points, you can cast any spell in the game (of Akashic Paths) as long as you know a spell of that level, except your highest level of spell. Any spell cast this way has its casting time increased by 1 step and cannot be reduced.",
                method:(levelObj, context)=>{
                    levelObj.doesNothing = {}
                    context.stats.lists.perks.push({
                        name:"Wild Magic",
                        prereq: "",
                        type:"magic",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"Once per day for level 2x plus the cost of the spell 2x spell points, you can cast any spell in the game (of Akashic Paths) as long as you know a spell of that level, except your highest level of spell. Any spell cast this way has its casting time increased by 1 step and cannot be reduced."
                    })
                }   
            },
            {
                id:3,
                name:"Multi-Dimensional Assault",
                desc:"Gain the perk Multi-Dimensional Assault: You can increase the DC's of your spells by your second highest mental stat by spending an additional 100% spell points while casting the spell.",
                method:(levelObj, context)=>{
                    levelObj.doesNothing = {}
                    context.stats.lists.perks.push({
                        name:"Multi-Dimensional Assault",
                        prereq: "",
                        type:"magic",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"You can increase the DC's of your spells by your second highest mental stat by spending an additional 100% spell points while casting the spell."
                    })
                }
            },
        ],
    },
    cleric:{
        tier1:[
            {
                id:1,
                name:"Improved Strength",
                desc:"Gain +2 strength",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.strength += 2
                }
            },
            {
                id:2,
                name:"Improved Wisdom",
                desc:"Gain +1 wisdom",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.wisdom += 1
                }
            },
            {
                id:3,
                name:"Ascetic",
                desc:"Gain +1 constitution and wisdom, but get -2 strength and dexterity",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.constitution += 1
                    levelObj.baseStatsMods.abilityScores.wisdom += 1
                    levelObj.baseStatsMods.abilityScores.strength -= 2
                    levelObj.baseStatsMods.abilityScores.dexterity -= 2
                }
            },
        ],
        tier2:[
            {
                id:1,
                name:"Toughen",
                desc:"Increase your HD size by 4",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.hdSize += 4
                }
            },
            {
                id:2,
                name:"Mental Toughness",
                desc:"Increase your spell points per level by +1.5 and base spell points by +4",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.spPerLevel += 1.5
                    levelObj.baseStatsMods.sp += 4
                }
            },
            { 
                id:3,
                name:"Improved Resistance",
                desc:"increase your fortitude by +1, and will by +2",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.fortitude += 1
                    levelObj.baseStatsMods.will += 2                    
                }
            },
        ],
        tier3:[
            {
                id:1,
                name:"Divine Knowledge",
                desc:"Gain +1 wisdom, +2 charisma, 2 level 1 spells, and 1 level 2 spell",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.charisma += 2
                    levelObj.baseStatsMods.abilityScores.wisdom += 1
                    levelObj.rollRequests.push({type:"spell", amount:2, options:{level:{lvl1:true}}})
                    levelObj.rollRequests.push({type:"spell", amount:1, options:{level:{lvl2:true}}})
                }
            },
            {
                id:2,
                name:"Healer",
                desc:"Gain +1 wisdom and your level 1 healing spell becomes cure light wounds, and your level 2 healing spell becomes cure moderate wounds",
                method:(levelObj, context)=>{
                    let lvl1Spell = levelObj.rollRequests.find(obj=> obj.type == "spell" && obj.options && obj.options.level.lvl1 && obj.options.type.healing)
                    let lvl2Spell = levelObj.rollRequests.find(obj=> obj.type == "spell" && obj.options && obj.options.level.lvl2 && obj.options.type.healing)
                    lvl1Spell.amount -= 1
                    lvl2Spell.amount -= 1
                    let spell1 = spells.filter(spell=> spell.name.includes("Cure Light Wounds"))
                    context.stats.lists.spells.push(spell1[0])
                    let spell2 = spells.filter(spell=> spell.name.includes("Cure Moderate Wounds"))
                    context.stats.lists.spells.push(spell2[0])
                }
            },
            {
                id:3,
                name:"Blessed Flesh",
                desc:"Gain +1 constitution and an R+ stat roll",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.constitution += 1
                    levelObj.rollRequests.push({type:"stats", amount:1, options:{rarity:{rare:true,epic:true,legendary:true,unique:true,}}})
                }
            },
        ],            
        tier4:[
            {
                id:1,
                name:"Defenses of the Faithful",
                desc:"One armor roll becomes R+ and one armor roll becomes a shield roll",
                method:(levelObj)=>{
                    let armor = levelObj.rollRequests.find(obj=> obj.type == "armor")
                    armor.amount -= 2
                    levelObj.rollRequests.push({type:"armor", amount:1, options:{armor:{rarity:{rare:true,epic:true,legendary:true,unique:true}}}})
                    levelObj.rollRequests.push({type:"armor", amount:1, options:{armor:{type:{shield:true}}}})
                }
            },
            {
                id:2,
                name:"Weapons of the Crusade",
                desc:"Gain a R+ two-handed weapon roll",
                method:(levelObj)=>{
                    levelObj.rollRequests.push({type:"weapon", amount:1, options:{weapon:{type:{twoHanded:true},rarity:{rare:true,epic:true,legendary:true,unique:true}}}})
                }
            },
            {
                id:3,
                name:"Technique's of the Savior",
                desc:"Gain 2 level 1-2 Silver Crane and Radiant Dawn Maneuvers",
                method:(levelObj)=>{
                    levelObj.rollRequests.push({type:"maneuver", amount:3, options:{school:{radiantDawn:true, silverCrane:true}, level:{lvl1:true,lvl2:true}}})
                }
            },
        ],
        tier5:[
            {
                id:1,
                name:"Restore SPirit",
                desc:"Gain +1 wisdom and the perk Restore SPirit: Whenever you cast a spell or use a maneuver that heals hit points the target also gains temporary spell points equal to the level of the spell or maneuver for 3 rounds. If the maneuver splits the healing the spell points are also split.",
                method:(levelObj, context)=>{
                    levelObj.baseStatsMods.abilityScores.wisdom += 1
                    context.stats.lists.perks.push({
                        name:"Restore SPirit",
                        prereq: "",
                        type:"magic",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"Whenever you cast a spell or use a maneuver that heals hit points the target also gains temporary spell points equal to the level of the spell or maneuver for 3 rounds. If the maneuver splits the healing the spell points are also split."
                    }) 
                }
            },
            {
                id:2,
                name:"Moment of Reprieve",
                desc:"Gain +1 constitution and the perk Moment of Reprieve: At the end of each floor roll a heal check, you can heal party members for hit points equal to the result of the check split among them. You can instead choose to restore 1 spell point instead of 4 hit points.",
                method:(levelObj, context)=>{
                    levelObj.baseStatsMods.abilityScores.constitution += 1
                    context.stats.lists.perks.push({
                        name:"Moment of Reprieve",
                        prereq: "",
                        type:"magic",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"At the end of each floor roll a heal check, you can heal party members for hit points equal to the result of the check split among them. Additionally you can choose to restore 1 spell point instead of 2 hit points."
                    }) 
                }
            },
            {
                id:3,
                name:"Divine Focus",
                desc:"Gain +2 wisdom and your unique perk becomes typed magic",
                method:(levelObj)=>{
                    levelObj.rollRequests[0].options.type = {magic:true}
                    levelObj.baseStatsMods.abilityScores.wisdom += 2
                }
            },
        ],
        tier6:[
            {
                id:1,
                name:"Vampiric Spells",
                desc:"Gain the perk Vampiric Spells: Once per round when you cast a spell that deals damage you heal for 1 hit point per damage dice rolled. If the spell dealt damage but rolled no dice instead heal 1 per level of the spell.",
                method:(levelObj, context)=>{
                    levelObj.doesNothing = {}
                    context.stats.lists.perks.push({
                        name:"Vampiric Spells",
                        prereq: "",
                        type:"magic",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"Once per round when you cast a spell that deals damage you heal for 1 hit point per damage dice rolled. If the spell dealt damage but rolled no dice instead heal 1 per level of the spell"
                    })
                }
            },
            {
                id:2,
                name:"Blessed Hands",
                desc:"Gain the perk Blessed Hands: Add your level to the healing of all spells and magical perks. If a spell doesn't roll dice to heal then instead increase the healing by the level of the spell. If a perk does not roll dice to heal then this perk does not affect it.",
                method:(levelObj, context)=>{
                    levelObj.doesNothing = {}
                    context.stats.lists.perks.push({
                        name:"Blessed Hands",
                        prereq: "",
                        type:"magic",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"Add your level to the healing of all spells and magical perks. If a spell doesn't roll dice to heal then instead increase the healing by the level of the spell. If a perk does not roll dice to heal then this perk does not affect it."
                    })
                }
            },
            {
                id:3,
                name:"Miracle of Salvation",
                desc:"Gain the perk Miracle of Salvation: Once per run you can spend level x3 spell points as a full round action to restore all party members to full health, and restore any dead party members to 50% hit points, however they gain a negative level. After using this perk all party members gain your highest mental stat as a sacred bonus to their armor class and saves for 1 round.",
                method:(levelObj, context)=>{
                    levelObj.doesNothing = {}
                    context.stats.lists.perks.push({
                        name:"Miracle of Salvation",
                        prereq: "",
                        type:"magic",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"Once per run you can spend level x3 spell points as a full round action to restore all party members to full health, and restore any dead party members to 50% hit points, however they gain a negative level. After using this perk all party members gain your highest mental stat as a sacred bonus to their armor class and saves for 1 round."
                    })
                }
            },
        ],
    },
    shaman:{
        tier1:[
            {
                id:1,
                name:"Improved Wisdom",
                desc:"Gain +1 wisdom.",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.wisdom += 1
                }
            },
            {
                id:2,
                name:"Voodoo Initiate",
                desc:"Gain a minor hex. Every 10 levels gain another minor hex.",
                method:(levelObj,context)=>{
                    levelObj.doNothing = "donothing"
                    let perk = perks.find(perk => perk.name == "Hexes")
                    perk.getHex(context, perk, 1)
                    context.stats.lists.perks.push({
                        name:"Voodoo Initiate",
                        prereq: "",
                        type:"magic",
                        rarity:"class",
                        uiType:"perks",
                        hasCustomMethod:true,
                        shortDesc:"Gain a minor hex. Every 10 levels gain another minor hex. Unless specified otherwise, they have a range of 30 feet, they are swift actions to activate, can be used once per day, cost 1 spell point, and their DC= 10 + level + highest mental."
                    }) 
                }
            },
            {
                id:3,
                name:"Scarred Shaman",
                desc:"Increase your natural armor by +2.",
                method:(levelObj,context)=>{
                    levelObj.doNothing = "donothing"
                    context.stats.lists.perks.push({
                        name:"Scarred Shaman",
                        prereq: "",
                        type:"universal",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"Increase your natural armor bonus by +2."
                    }) 
                    context.stats.statsForAbilities.ac.natural += 2
                }
            },
        ],
        tier2:[
            {
                id:1,
                name:"Toughen",
                desc:"Increase your HD size by 3",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.hdSize += 3
                }
            },
            {
                id:2,
                name:"Mental Toughness",
                desc:"Increase your spell points per level by +1.5 and base spell points by +4",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.spPerLevel += 1.5
                    levelObj.baseStatsMods.sp += 4
                }
            },
            { 
                id:3,
                name:"Improved Resistance",
                desc:"increase your fortitude by +1 and will by +2",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.fortitude += 1
                    levelObj.baseStatsMods.will += 2
                }
            },
        ],
        tier3:[
            {
                id:1,
                name:"Hexer's Knowledge",
                desc:"Gain +1 wisdom, 2 control spells and 2 healing spells",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.wisdom += 1
                    levelObj.rollRequests.push({type:"spell", amount:2, options:{level:{lvl1:true,lvl2:true},type:{control:true}}})
                    levelObj.rollRequests.push({type:"spell", amount:2, options:{level:{lvl1:true,lvl2:true},type:{control:true}}})
                }
            },
            {
                id:2,
                name:"Voodoo Adept",
                desc:"At level 1 you will gain a minor hex. Every 8 levels you will gain a minor-major hex.",
                method:(levelObj, context)=>{
                    levelObj.doNothing = "donothing"
                    let perk = perks.find(perk => perk.name == "Hexes")
                    perk.getHex(context, perk, 1)
                    context.stats.lists.perks.push({
                        name:"Voodoo Adept",
                        prereq: "",
                        type:"magic",
                        rarity:"class",
                        uiType:"perks",
                        hasCustomMethod:true,
                        shortDesc:"Gain a minor hex. Every 8 levels you will gain a minor-major hex. Unless specified otherwise, they have a range of 30 feet, they are swift actions to activate, can be used once per day, cost 1 spell point, and their DC= 10 + level + highest mental. Major hexes are like minor hexes except they cost 4 spell points instead."
                    }) 
                }
            },
            {
                id:3,
                name:"Imbued With Spirits",
                desc:"Gain +1 constitution and an R+ stat roll",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.constitution += 1
                    levelObj.rollRequests.push({type:"stats", amount:1, options:{rarity:{rare:true,epic:true,legendary:true,unique:true,}}})
                }
            },
        ],            
        tier4:[
            {
                id:1,
                name:"Shaman Blessed Garbs",
                desc:"Gain an enchanted clothing/light armor roll.",
                method:(levelObj)=>{
                    levelObj.rollRequests.push({type:"armor", amount:1, options:{armor:{type:{clothing:true,light:true}, enchanted:true}}})
                }
            },
            {
                id:2,
                name:"wip(4,2)",
                desc:"wip",
                method:(levelObj)=>{
                    levelObj.rollRequests.push({type:"weapon", amount:1, options:{weapon:{type:{twoHanded:true},rarity:{rare:true,epic:true,legendary:true,unique:true}}}})
                }
            },
            {
                id:3,
                name:"Nature's Bounty",
                desc:"Increase your starting gold by 50.",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.gold += 50
                }
            },
        ],
        tier5:[
            {
                id:1,
                name:"Magic Focus",
                desc:"Gain +2 wisdom and your unique perk becomes typed magic",
                method:(levelObj)=>{
                    levelObj.rollRequests[0].options.type = {magic:true}
                    levelObj.baseStatsMods.abilityScores.wisdom += 2
                }
            },
            {
                id:2,
                name:"Voodoo Master",
                desc:"You gain +1 wisdom, and at level 1 you will gain a minor hex. Every 6 levels you will gain a minor-grand hex, depending on your level.",
                method:(levelObj, context)=>{
                    levelObj.baseStatsMods.abilityScores.wisdom += 1
                    let perk = perks.find(perk => perk.name == "Hexes")
                    perk.getHex(context, perk, 1)
                    context.stats.lists.perks.push({
                        name:"Voodoo Master",
                        prereq: "",
                        type:"magic",
                        rarity:"class",
                        uiType:"perks",
                        hasCustomMethod:true,
                        shortDesc:"Gain a minor hex. Every 6 levels you will gain a minor-grand hex, depending on your level. Unless specified otherwise, they have a range of 30 feet, they are swift actions to activate, can be used once per day, cost 1 spell point, and their DC = 10 + level + highest mental. Major hexes are like minor hexes except they cost 4 spell points instead. Grand hexes cost 8 spell points."
                    }) 
                }
            },
            {
                id:3,
                name:"Gift from the Spirits",
                desc:"You gain +2 dexterity You gain an enchanted Voodoo Doll.",
                method:(levelObj, context)=>{
                    levelObj.doesNothing = {}
                    levelObj.baseStatsMods.abilityScores.dexterity += 2
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"weapon", options:{enchanted:true, name:"Voodoo Doll"}}))
                }
            },
        ],
        tier6:[
            {
                id:1,
                name:"wip(6,1)",
                desc:"wio",
                method:(levelObj)=>{
                    levelObj.doesNothing = {}
                }
            },
            {
                id:2,
                name:"Gift from the Spirits",
                desc:"You gain an enchanted Voodoo Doll.",
                method:(levelObj, context)=>{
                    levelObj.doesNothing = {}
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"weapon", options:{enchanted:true, name:"Voodoo Doll"}}))
                }
            },
            {
                id:3,
                name:"Master of Black Magic",
                desc:"Increase the DC of all control spells you cast by +1. Every 8 levels you increase the bonus by +1.",
                method:(levelObj,context)=>{
                    levelObj.doNothing = "donothing"
                    context.stats.lists.perks.push({
                        name:"Master of Black Magic",
                        prereq: "",
                        type:"magic",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"Increase the DC of all control spells you cast by +1. Every 8 levels you increase the bonus by +1."
                    }) 
                }
            },
        ],
    },
    alchemist:{
        tier1:[
            {
                id:1,
                name:"Improved Intelligence",
                desc:"Gain +1 intelligence.",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.intelligence += 1
                }
            },
            {
                id:2,
                name:"Alchemic Preperations",
                desc:"At the start of the game you get a random curative, mnemonic, and restorative potions",
                method:(levelObj,context)=>{
                    levelObj.doNothing = "donothing"
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"potions", options:{type:"curative"}}))
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"potions", options:{type:"mnemonic"}}))
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"potions", options:{type:"restorative"}}))
                }
            },
            {
                id:3,
                name:"Yay Grenades",
                desc:"Gain a random grenade roll",
                method:(levelObj,context)=>{
                    levelObj.doNothing = "donothing"
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"Gear", options:{type:{grenade:true}}}))
                }
            },
        ],
        tier2:[
            {
                id:1,
                name:"Toughen",
                desc:"Increase your HD size by 3",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.hdSize += 3
                }
            },
            {
                id:2,
                name:"Mental Toughness",
                desc:"Increase your spell points per level by +1.5 and base spell points by +4",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.spPerLevel += 1.5
                    levelObj.baseStatsMods.sp += 4
                }
            },
            { 
                id:3,
                name:"Improved Resistance",
                desc:"Increase your fortitude by +1 and will by +1",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.fortitude += 1
                    levelObj.baseStatsMods.will += 1
                }
            },
        ],
        tier3:[
            {
                id:1,
                name:"Mutation",
                desc:"Gain a +4 bonus to a random ability score, a -2 to another ability score, and a +2 bonus to your natural armor.",
                method:(levelObj, context)=>{
                    let abilityScores = ["strength","constitution","dexterity","wisdom","intelligence","charisma"]
                    let num = Math.floor(Math.random()*abilityScores.length)
                    let random = abilityScores[num]
                    levelObj.baseStatsMods.abilityScores[random] += 4
                    abilityScores.splice(num,1)
                    let random2 = abilityScores[Math.floor(Math.random()*abilityScores.length)]
                    levelObj.baseStatsMods.abilityScores[random2] -= 2
                    context.stats.statsForAbilities.ac.natural += 2

                    context.stats.lists.perks.push({
                        name:"Mutation",
                        prereq: "",
                        type:"universal",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"You were mutated, gaining a +4 bonus to your " + random + " , a -2 penalty to your " + random2 + " , and gaining a +2 bonus to your natural armor."
                    }) 
                }
            },
            {
                id:2,
                name:"Potion Crafter",
                desc:"Gain the perk Potion Crafter: At the beginning of each floor you make a craft roll, for each 10 of the result, you gain a random potion.",
                method:(levelObj, context)=>{
                    levelObj.doNothing = "donothing"
                    context.stats.lists.perks.push({
                        name:"Potion Crafter",
                        prereq: "",
                        type:"universal",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"At the beginning of each floor you make a craft roll, for each 10 of the result, you gain a random potion."
                    }) 
                }
            },
            {
                id:3,
                name:"Tested Fortitude",
                desc:"Gain +1 constitution and an R+ stat roll",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.constitution += 1
                    levelObj.rollRequests.push({type:"stats", amount:1, options:{rarity:{rare:true,epic:true,legendary:true,unique:true,}}})
                }
            },
        ],            
        tier4:[
            {
                id:1,
                name:"Hip Flask",
                desc:"Gain the perk Hip Flask: Once per floor you can as a swift action that doesn't provoke attacks of opportunity take a swig from your special hip flask. Doing so allows you to make a craft check, you can choose to either heal hit points equal to the result of the check, or to restore spell points equal to 1/4 the result of the check.",
                method:(levelObj,context)=>{
                    levelObj.doNothing = "donothing"
                    context.stats.lists.perks.push({
                        name:"Hip Flask",
                        prereq: "",
                        type:"universal",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"Once per floor you can as a swift action that doesn't provoke attacks of opportunity take a swig from your special hip flask. Doing so allows you to make a craft check, you can choose to either heal hit points equal to the result of the check, or to restore spell points equal to 1/4 the result of the check."
                    }) 
                }
            },
            {
                id:2,
                name:"Full Metal Jacket",
                desc:"Your light armor roll becomes a heavy armor roll.",
                method:(levelObj)=>{
                    let armor = levelObj.rollRequests.find(obj=> obj.type == "armor")
                    armor.amount -= 1
                    levelObj.rollRequests.push({type:"armor", amount:1, options:{armor:{type:{heavy:true}}}})
                }
            },
            {
                id:3,
                name:"Philosopher's Stone",
                desc:"Gain the Perk Philosopher's Stone: Once per floor you can spend 5 spell points to gain 1 gold. You can spend as many spell points at a time as you'd like. Perks or abilities that reduce spell point costs do not work on this perk.",
                method:(levelObj,context)=>{
                    levelObj.doNothing = "donothing"
                    context.stats.lists.perks.push({
                        name:"Philosopher's Stone",
                        prereq: "",
                        type:"universal",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"Once per floor you can spend 5 spell points to gain 1 gold. You can spend as many spell points at a time as you'd like. Perks or abilities that reduce spell point costs do not work on this perk."
                    }) 
                }
            },
        ],
        tier5:[
            {
                id:1,
                name:"Magic Focus",
                desc:"Gain +2 intelligence and your unique perk becomes typed magic",
                method:(levelObj)=>{
                    levelObj.rollRequests[0].options.type = {magic:true}
                    levelObj.baseStatsMods.abilityScores.intelligence += 2
                }
            },
            {
                id:2,
                name:"Imbued Potions",
                desc:"Gain the perk Imbued Potions: Curative or Mnemonic potions you drink or feed to allies have their amount restored increased by 25%",
                method:(levelObj, context)=>{
                    levelObj.doNothing = "donothing"
                    context.stats.lists.perks.push({
                        name:"Imbued Potions",
                        prereq: "",
                        type:"magic",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"Curative or Mnemonic potions you drink or feed to allies have their amount restored increased by 25%"
                    }) 
                }
            },
            {
                id:3,
                name:"Potion Salves",
                desc:"You gain the perk Potion Salves: You can apply a potion to an ally as a standard action even if they are conscious. This costs spell points equal to the potions level.",
                method:(levelObj, context)=>{
                    levelObj.doNothing = "donothing"
                    context.stats.lists.perks.push({
                        name:"Potion Salves",
                        prereq: "",
                        type:"magic",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"You can apply a potion to an ally as a standard action even if they are conscious. This costs spell points equal to the potions level."
                    }) 
                }
            },
        ],
        tier6:[
            {
                id:1,
                name:"Ready Alchemist",
                desc:"Gain the perk Ready Alchemist: Once per combat you can draw or drink a potion as swift action and it no longer provokes an attack of opportunity.",
                method:(levelObj, context)=>{
                    levelObj.doesNothing = {}
                    context.stats.lists.perks.push({
                        name:"Ready Alchemist",
                        prereq: "",
                        type:"universal",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"Once per combat you can draw a potion as swift action and it no longer provokes an attack of opportunity."
                    })
                }
            },            
            {
                id:2,
                name:"Overflowing Crafting",
                desc:"Gain the perk Overflowing Crafting: At the beginning of each floor you make a craft roll, for each 10 of the result, you gain a random potion.",
                method:(levelObj, context)=>{
                    levelObj.doNothing = "donothing"
                    context.stats.lists.perks.push({
                        name:"Overflowing Crafting",
                        prereq: "",
                        type:"universal",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"At the beginning of each floor you make a craft roll, for each 10 of the result, you gain a random potion."
                    }) 
                }
            },
            {
                id:3,
                name:"Potion Injection",
                desc:"At the start of each floor you gain a potion injector. You can automatically apply it to yourself if you'd like.",
                method:(levelObj, context)=>{
                    levelObj.doesNothing = {}
                    context.stats.lists.perks.push({
                        name:"Potion Injection",
                        prereq: "",
                        type:"universal",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"At the start of each floor you gain a potion injector. You can automatically apply it to yourself if you'd like."
                    })
                }
            },
        ],
    },
    sorcerer:{
        tier1:[
            {
                id:1,
                name:"Force of Will",
                desc:"Gain +1 charisma",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.charisma += 1
                }
            },
            {
                id:2,
                name:"Socialite",
                desc:"Gain +3 charisma, but -2 strength and -1 constitution",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.charisma += 3
                    levelObj.baseStatsMods.abilityScores.constitution -= 1
                    levelObj.baseStatsMods.abilityScores.strength -= 2
                }
            },
            {
                id:3,
                name:"Battle Mage",
                desc:"Gain +2 dexterity and strength, but -2 wisdom",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.dexterity += 2
                    levelObj.baseStatsMods.abilityScores.strength += 2
                    levelObj.baseStatsMods.abilityScores.wisdom -= 2
                }
            },
        ],
        tier2:[
            {
                id:1,
                name:"Toughen",
                desc:"Increase your HD size by 2",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.hdSize += 2
                }
            },
            {
                id:2,
                name:"Mental Toughness",
                desc:"Increase your spell points per level by +2 and base spell points by +4",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.spPerLevel += 2
                    levelObj.baseStatsMods.sp += 4
                }
            },
            { 
                id:3,
                name:"Improved Resistance",
                desc:"increase your fortitude and will save by +1",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.will += 1
                    levelObj.baseStatsMods.fortitude += 1
                }
            },
        ],
        tier3:[
            {
                id:2,
                name:"Arcane Knowledge",
                desc:"Gain +1 charisma, and 2 level 1 and 1 level 2 damage spells",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.charisma += 1
                    levelObj.rollRequests.push({type:"spell", amount:2, options:{level:{lvl1:true}, type:{damage:true}}})
                    levelObj.rollRequests.push({type:"spell", amount:1, options:{level:{lvl2:true}, type:{damage:true}}})
                }
            },
            {
                id:2,
                name:"Battle Archmage",
                desc:"Gain +2 strength and 2 weapon rolls",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.strength += 2
                    let weapon = levelObj.rollRequests.find(obj=> obj.type == "weapon")
                    weapon.amount += 2
                }
            },
            {
                id:3,
                name:"Improved Genetics",
                desc:"Gain +1 constitution and an R+ stat roll",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.constitution += 1
                    levelObj.rollRequests.push({type:"stats", amount:1, options:{rarity:{rare:true,epic:true,legendary:true,unique:true,}}})
                }
            },
        ],            
        tier4:[
            {
                id:1,
                name:"Fiendish Deal",
                desc:"One of your magic perks becomes an R+ magic perk, but you get -2 constitution",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.constitution -= 2
                    let perk = levelObj.rollRequests.find(obj=> obj.type == "perks" && obj.options.type.magic)
                    perk.amount -=1
                    levelObj.rollRequests.push({type:"perks", options:{type:{magic:true}, rarity:{rare:true,epic:true,legendary:true,unique:true}}, amount:2})
                }
            },
            {
                id:2,
                name:"Casters Vestments",
                desc:"Gain a light armor and a clothing roll",
                method:(levelObj)=>{
                    levelObj.rollRequests.push({type:"armor", amount:1, options:{armor:{type:{light:true}}}})
                    levelObj.rollRequests.push({type:"armor", amount:1, options:{armor:{type:{clothing:true}}}})
                }
            },
            {
                id:3,
                name:"Metamage",
                desc:"Turn your feat into a metamagic feat",
                method:(levelObj)=>{
                    let feat = levelObj.rollRequests.find(obj=> obj.type == "feats")
                    feat.amount -=1
                    levelObj.rollRequests.push({type:"feats", options:{metamagic:true}, amount:1})
                }
            },
        ],
        tier5:[
            {
                id:1,
                name:"Magical Lineage",
                desc:"Gain +1 charisma and the perk Magical Lineage: Reduce the level modification of metamagic perks by 1, reducing its spell point cost and the the spell level known required to use the metamagic feat by 1.",
                method:(levelObj, context)=>{
                    levelObj.baseStatsMods.abilityScores.charisma += 1
                    context.stats.lists.perks.push({
                        name:"Magical Lineage",
                        prereq: "",
                        type:"magic",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"Reduce the level modification of metamagic perks by 1, reducing its spell point cost and the the spell level known required to use the metamagic feat by 1."
                    })
                }
            },
            {
                id:2,
                name:"Magical Training",
                desc:"Gain +2 charisma and your unique perk becomes typed magic",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.charisma += 2
                    levelObj.rollRequests[0].options.type = {magic:true}
                }
            },
            {
                id:3,
                name:"Soul Shield",
                desc:"Gain +1 constitution and the perk Soul Shield: Once per day as an immediate action you can activate this perk, the damage you take for the rest of the round is instead dealt to your spell points, if you run out of spell points the damage is dealt to your health as normal.",
                method:(levelObj, context)=>{
                    levelObj.baseStatsMods.abilityScores.constitution += 1
                    context.stats.lists.perks.push({
                        name:"Soul Shield",
                        prereq: "",
                        type:"magic",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"Once per day as an immediate action you can activate this perk, the damage you take for the rest of the round is instead dealt to your spell points, if you run out of spell points the damage is dealt to your health as normal."
                    })
                }
            },
        ],
        tier6:[
            {
                id:1,
                name:"Bloodline Havoc",
                desc:"Gain the perk Bloodline Havoc: Your damage spells deal +1 damage per dice rolled for damage.",
                method:(levelObj, context)=>{
                    levelObj.doesNothing = {}
                    context.stats.lists.perks.push({
                        name:"Bloodline Havoc",
                        prereq: "",
                        type:"magic",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"Your damage spells deal +1 damage per dice rolled for damage"
                    })
                }
            },
            {
                id:2,
                name:"Fueled by Destruction",
                desc:"Gain the perk Fueled by Destruction: Whenever you land the killing blow on a non-helpless creature you regain spell points equal to your highest mental score-10.",
                method:(levelObj, context)=>{
                    levelObj.doesNothing = {}
                    context.stats.lists.perks.push({
                        name:"Fueled by Destruction",
                        prereq: "",
                        type:"magic",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"Whenever you land the killing blow on a non-helpless creature you regain spell points equal to your highest mental score-10."
                    })
                }
            },
            {
                id:3,
                name:"Limit Breaking Spell",
                desc:"Gain the perk Limit Breaker Spell: Increase the maximum number of damage dice for all spells by 3 levels.",
                method:(levelObj, context)=>{
                    levelObj.doesNothing = {}
                    context.stats.lists.perks.push({
                        name:"Limit Breaking Spell",
                        prereq: "",
                        type:"magic",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"Increase the maximum number of damage dice for all spells by 3 levels."
                    })
                }
            },
        ],
    },
    prodigy:{
        tier1:[
            {
                id:1,
                name:"Improved Intelligence",
                desc:"Increase your intelligence by +2",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.intelligence += 2
                }
            },
            {
                id:2,
                name:"Improved Constitution",
                desc:"Increase your constition by +1.",
                method:(levelObj)=>{                    
                    levelObj.baseStatsMods.abilityScores.constitution += 1
                }
            },
            {
                id:3,
                name:"Swap Speciality",
                desc:"Gain +4 strength, but reduce intelligence by -2",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.strength += 4
                    levelObj.baseStatsMods.abilityScores.intelligence -= 2
                }
            },
        ],
        tier2:[
            {
                id:1,
                name:"Toughen",
                desc:"Increase your HD size by 2",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.hdSize += 2
                }
            },
            {
                id:2,
                name:"Mental Toughness",
                desc:"Increase your spell points per level by +1 and base spell points by 7",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.spPerLevel += 1
                    levelObj.baseStatsMods.sp += 7
                }
            },
            { 
                id:3,
                name:"Improved Resistance",
                desc:"increase your will save by +4 and reduce your reflex and fortitude save by -1",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.will += 4
                    levelObj.baseStatsMods.reflex -= 1
                    levelObj.baseStatsMods.fortitude -= 1
                }
            },
        ],
        tier3:[
            {
                id:1,
                name:"Basic Universal Study",
                desc:"Gain +1 intelligence, 1 level 1-2 maneuver and 1 level 1-2 spell",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.intelligence += 1
                    levelObj.rollRequests.push({type:"maneuver", amount:1, options:{level:{lvl1:true,lvl2:true}}})
                    levelObj.rollRequests.push({type:"spell", amount:1, options:{level:{lvl1:true,lvl2:true}}})
                }
            },
            {
                id:2,
                name:"Improved Genetics",
                desc:"Gain +1 constitution and an R+ stats",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.constitution += 1
                    levelObj.rollRequests.push({type:"stats", amount:1, options:{rarity:{rare:true,epic:true,legendary:true,unique:true,}}})
                }
            },
            {
                id:3,
                name:"Skillfull",
                desc:"Gain +2 intelligence and 2 skill rolls",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.intelligence += 2
                    levelObj.rollRequests.push({type:"stats", amount:2, options:{type:{skills:true}}})
                }
            },
        ],            
        tier4:[
            {
                id:1,
                name:"Key Studies",
                desc:"Lose 1 constitution and gain a key feat",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.constitution -= 1
                    levelObj.rollRequests.push({type:"feats", amount:1, options:{martial:true, magic:true, utility:true, style:true, metamagic:true, key:true, prereq:true,}})
                }
            },
            {
                id:2,
                name:"Polystudy",
                desc:"Gain 2 level 1 maneuvers and 2 level 1 spells",
                method:(levelObj)=>{
                    levelObj.rollRequests.push({type:"spell", amount:2, options:{level:{lvl1:true}}})
                    levelObj.rollRequests.push({type:"maneuvers", amount:2, options:{level:{lvl1:true}}})

                }
            },
            {
                id:3,
                name:"Expanded Pockets",
                desc:"Gain 100 gold",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.gold += 100
                }
            },
        ],
        tier5:[
            {
                id:1,
                name:"All Consuming Study",
                desc:"Gain 1 perk, but lose 2 constitution",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.constitution -= 1
                    levelObj.rollRequests.push({type:"perks", amount:1})
                }
            },
            {
                id:2,
                name:"Trade Self Respect",
                desc:"Gain +4 constitution, lose self respect",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.constitution += 4
                }
            },
            {
                id:3,
                name:"Ultimate Trade",
                desc:"lose 4 skill rolls, 3 stat rolls, 2 hd size, a level 2 spell, a maneuver, and gain a third unique perk",
                method:(levelObj)=>{                    
                    let stats = levelObj.rollRequests.find(obj=> obj.type == "stats")
                    stats.amount -= 3
                    let skills = levelObj.rollRequests.find(obj=> obj.type == "stats" && obj.options && obj.options.type.skills)
                    skills.amount -= 3
                    let spell = levelObj.rollRequests.find(obj=> obj.type == "spell" && obj.options && obj.options.level.lvl2)
                    spell.amount -= 1
                    let maneuver = levelObj.rollRequests.find(obj=> obj.type == "maneuver")
                    maneuver.amount -= 1
                    levelObj.baseStatsMods.hdSize -= 2
                    levelObj.rollRequests[0].amount +=1
                }
            },
        ],
        tier6:[
            {
                id:1,
                name:"Prodigy Maxxing",
                desc:"Gain a R+ perk, but lose 2 constitution",
                method:(levelObj)=>{
                    levelObj.baseStatsMods.abilityScores.constitution -= 2
                    levelObj.rollRequests.push({type:"perks", amount:1, options:{rarity:{rare:true,epic:true,legendary:true,unique:true}}})
                }
            },
            {
                id:2,
                name:"Fast Learner",
                desc:"Gain the perk Fast Learner: Gain 10% bonus experience",
                method:(levelObj, context)=>{
                    levelObj.doesNothing = {}
                    context.stats.lists.perks.push({
                        name:"Fast Learner",
                        prereq: "",
                        type:"universal",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"Gain 10% bonus experience"
                    })
                }
            },
            {
                id:3,
                name:"Talented Activation",
                desc:"Gain the perk Talented Activation: Reduce the cost of all abilities, spells, and maneuvers you use by 1 spell point, abilities can cost 0 spell point now.",
                method:(levelObj,context)=>{
                    levelObj.doesNothing = {}
                    context.stats.lists.perks.push({
                        name:"Talented Activation",
                        prereq: "",
                        type:"universal",
                        rarity:"class",
                        uiType:"perks",
                        shortDesc:"Reduce the cost of all abilities, spells, and maneuvers you use by 1 spell point, abilities can cost 0 spell point now."
                    })
                }
            },
        ],
    },
}